
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "公告详情":"รายละเอียดการประกาศ",
  "未读":"ยังไม่ได้อ่าน",
  "已读":"อ่าน",
  "主动取消":"ยกเลิก",
  "申请拒绝":"การปฏิเสธการสมัคร",
  "赎回拒绝":"การปฏิเสธการไถ่ถอน",
  "重新申请":"สมัครใหม่อีกครั้ง",
  "撤回申请":"การถอนคำสมัคร",
  "在这里购买有潜力的":"ซื้อศักยภาพได้ที่นี่",
    "什么是新币申购？":"สมัครสมาชิกเหรียญใหม่คืออะไร?",
    "投资价值高":"มูลค่าการลงทุนสูง",
    "新币价格低，潜在价值高，适合投资":"สกุลเงินใหม่มีราคาต่ำและมูลค่าศักยภาพสูง เหมาะกับการลงทุน",
    "无手续费":"ไม่มีค่าธรรมเนียมการจัดการ",
    "购买新币不需要任何手续费":"ไม่ต้องเสียค่าธรรมเนียมในการซื้อเหรียญใหม่",
    "是交易产品中风险最低且收益稳定的一种投资方式":"เป็นวิธีการลงทุนที่มีความเสี่ยงต่ำที่สุดและให้ผลตอบแทนที่มั่นคงในบรรดาผลิตภัณฑ์การซื้อขาย",
    "产品":"ผลิตภัณฑ์",
    "我的申购订单":"ใบสั่งซื้อของฉัน",
    "总数量":"ปริมาณรวม",
    "已认购量":"จำนวนเงินที่สมัคร",
    "剩余数量":"ปริมาณคงเหลือ",
    "锁仓天数":"วันล็อคอัพ",
    "浅色模式":"โหมดแสง",
    "深色模式":"โหมดมืด",
  "修改昵称":"เปลี่ยนชื่อเล่น",
  "昵称":"ชื่อเล่น",
  "头像":"อวาตาร์",
  "绑定邮箱":"ผูกอีเมล",
  "绑定手机号":"ผูกหมายเลขโทรศัพท์",
  "未绑定":"ยังไม่ผูก",
  "上传头像":"อัปโหลดภาพโปรไฟล์",
  "修改头像":"แก้ไขภาพโปรไฟล์",
  "个人信息":"ข้อมูลส่วนตัว",
  "我们发送了验证码至":"เราได้ส่งรหัสยืนยันไปที่",
  "中":"ใน",
  "请输入获取到的验证码以激活账户":"กรุณาใส่รหัสยืนยันเพื่อเปิดใช้งานบัญชี",
    "请输入昵称":"กรุณากรอกชื่อเล่นของคุณ",
    "手机号":"เบอร์โทรศัพท์",
    "邮箱号":"ที่อยู่อีเมล์",
    "请输入邮箱号":"กรุณากรอกที่อยู่อีเมล์ของคุณ",
  "白皮书":"กระดาษขาว",
  "驾驶证":"ใบขับขี่",
  "居住证":"บัตรประชาชน",
  "通过时间":"เวลาที่ใช้",
  "银行账户":"บัญชีธนาคาร",
    "请输入银行账户":"กรุณากรอกหมายเลขบัญชีธนาคาร",
    "银行国际代码":"รหัส SWIFT",
    "请输入国际代码":"กรุณากรอกรหัสต่างประเทศ",
    "电话号码":"หมายเลขโทรศัพท์",
    "请输入电话号码":"กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
    "上传房屋证明":"อัปโหลดหลักฐานที่อยู่อาศัย",
    "上传收入证明":"อัปโหลดหลักฐานรายได้",
    "上传银行证明":"อัปโหลดหลักฐานจากธนาคาร",
    "上传证件照":"อัปโหลดรูปถ่ายบัตรประจำตัว",
    "提示:您可以通过上传证明来提高信用分":"เคล็ดลับ: คุณสามารถปรับปรุงคะแนนเครดิตของคุณได้โดยการอัปโหลดหลักฐาน",
    "谷歌验证码":"รหัส Google",
    "修改谷歌验证码":"แก้ไขรหัสยืนยัน Google",
    "扫描二维码绑定":"สแกนรหัส QR เพื่อผูกบัญชี",
    "输入验证码":"ป้อนรหัสยืนยัน",
    "你知道吗？":"คุณรู้หรือไม่",
    "绑定2FA认证,提款时需要取得您的认证,资金更安全":"ผูกบัญชี 2FA เพื่อการถอนเงินที่ปลอดภัยยิ่งขึ้น",
    "立即绑定":"ผูกบัญชีทันที",
    "请输入原绑定的谷歌验证码":"ป้อนรหัสยืนยัน Google ดั้งเดิม",
    "重新绑定":"ผูกบัญชีใหม่",
    "交易密码":"รหัสผ่านธุรกรรม",
    "请输入交易密码":"กรุณาป้อนรหัสผ่าน",
    "请输入谷歌验证码":"กรุณาป้อนรหัส Google",
    "请到安全中心设置交易密码":"ตั้งรหัสผ่านธุรกรรมในศูนย์ความปลอดภัย  ",
    "请到安全中心设置谷歌验证":"ตั้งค่าการยืนยัน Google ในศูนย์ความปลอดภัย",
    "请输入验证码":"กรุณาป้อนรหัส",
    "信用分":"เครดิตสกอร์",
  "关闭":"ปิด",
  "查看详情":"ดูรายละเอียด",
  "向卖家付款":"การจ่ายเงินให้กับผู้ขาย",
    "获取您的币种":"รับสกุลเงินของคุณ",
    "我的订单":"คำสั่งซื้อของฉัน",
    "未匹配":"ไม่ตรงกัน",
    "已匹配":"ตรงกัน",
    "已完成":"ที่เสร็จเรียบร้อย",
    "已过期":"หมดอายุแล้ว",
    "合同号":"เลขที่สัญญา",
      "买入金额":"จำนวนการซื้อ",
      "邮箱":"เมล",
      "请输入您的电子邮箱":"กรุณากรอกที่อยู่อีเมล์ของคุณ",
      "请选择购买的货币":"กรุณาเลือกสกุลเงินที่คุณต้องการซื้อ",
      "请选择支付的货币":"กรุณาเลือกสกุลเงินในการชำระเงิน",
      "请填写您的收款信息，如有需要补充信息请填写到备注栏或者联系客服。":"กรุณากรอกข้อมูลการชำระเงิน หากต้องการข้อมูลเพิ่มเติม กรุณากรอกในช่องหมายเหตุ หรือติดต่อฝ่ายบริการลูกค้า",
      "备注":"หมายเหตุ",
      "请选择币种":"กรุณาเลือกสกุลเงิน",
      "请输入钱包地址":"กรุณากรอกที่อยู่กระเป๋าเงินของคุณ",
      "绑定钱包":"กระเป๋าสตางค์ผูกมัด",
      "钱包地址":"ที่อยู่กระเป๋าเงิน",
      "请输入备注":"กรุณาใส่ความคิดเห็น",
      "提现地址":"ที่อยู่สำหรับการถอนเงิน",
      "添加钱包地址":"เพิ่มที่อยู่กระเป๋าเงิน",
      "钱包管理":"การจัดการกระเป๋าสตางค์",
    "重要提示：":"เคล็ดลับสำคัญ:",
    "订单有效期：买方或卖方需在发起订单后3小时内完成交易。如未能完成，请及时联系在线客服确认订单状态。":"ระยะเวลาที่คำสั่งซื้อมีผล: ผู้ซื้อหรือผู้ขายจะต้องดำเนินการธุรกรรมให้เสร็จสิ้นภายใน 3 ชั่วโมงหลังจากเริ่มสั่งซื้อ หากไม่สามารถดำเนินการให้เสร็จสิ้นได้ กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์เพื่อยืนยันสถานะคำสั่งซื้อ",
    "订单失效：若未在规定时间内联系客服，订单将自动失效，无法恢复。":"วันหมดอายุของคำสั่งซื้อ: หากคุณไม่ติดต่อฝ่ายบริการลูกค้าภายในเวลาที่กำหนด คำสั่งซื้อจะหมดอายุโดยอัตโนมัติ และไม่สามารถเรียกคืนได้",
    "安全保障：我们提供全面的交易保障措施，确保您的资金和交易信息安全。":"ความปลอดภัย: เราจัดให้มีมาตรการป้องกันธุรกรรมที่ครอบคลุมเพื่อให้แน่ใจถึงความปลอดภัยของเงินทุนและข้อมูลธุรกรรมของคุณ",

    "充值":"เงินฝาก",
    "提现":"ถอน",
    "兑换":"แลกเปลี่ยน",
    "今日收益":"รายได้วันนี้",
    "现金":"เงินสด",
    "交易":"ซื้อขาย",
    "理财":"การจัดการทางการเงิน",
    "资产列表":"รายการสินทรัพย์",
  "已锁仓":"ล็อค",
  "最高可贷款":"จำนวนเงินกู้สูงสุด",
  "请先完成高级认证":"กรุณาทำการตรวจสอบขั้นสูงให้เสร็จสิ้น",
  "贷款金额":"จำนวนเงินกู้",
  "总还款额":"ยอดชำระคืนทั้งหมด",
  "金融":"การเงิน",
  "选择周期":"เลือกรอบการปั่น",
  "选择类型":"เลือกประเภท",
  "结算价":"ราคาชำระหนี้",
  "限价卖出":"ขายจำกัด",
  "截止价卖出":"ขายหยุด",
  "加密货币":"การเข้ารหัสลับ",
  "银行卡":"บัตรธนาคาร",
  "金额":"จำนวน",
  "选择银行":"เลือกธนาคาร",
  "提款需要的手续费,这需要由网络节点确认, 才能记入请不要将加密货币转让给陌生人":"ค่าธรรมเนียมการถอนจะต้องได้รับการยืนยันจากโหนดเครือข่ายก่อนจึงจะสามารถโอนได้ โปรดอย่าโอนสกุลเงินดิจิทัลให้กับคนแปลกหน้า",
  "银行卡管理":"การจัดการบัตรธนาคาร",
  "绑定银行卡":"ผูกบัตรธนาคาร",
  "添加":"เพิ่ม",
  "添加银行卡":"เพิ่มบัตรธนาคาร",
  "修改银行卡":"ปรับเปลี่ยนบัตรธนาคาร",
  "请添加银行卡":"กรุณาเพิ่มบัตรธนาคาร",
  "数量":"ปริมาณ",
  "继续下单":"ดำเนินการต่อ",
  "路由号码":"หมายเลขเส้นทาง",
  "请输入路由号码":"กรุณากรอกหมายเลขเส้นทาง",
  "搜索":"ค้นหา",

  "限价买入":"ซื้อแบบจำกัด",
  "截止价买入":"ซื้อแบบราคาหยุด",
  "限价卖出":"ขายจำกัด",
  "截止价卖出":"ขายหยุด",
  "贷款金额":"จำนวนเงินกู้",
  "总还款额":"ยอดชำระคืนทั้งหมด",
  "委托总量":"ทั้งหมด",
  "交易总额":"จํานวนธุรกรรมทั้งหมด",
  "成交价格":"ราคาซื้อขาย",
  "委托价格":"ราคาคอมมิชชั่น",
  "顶尖交易技术":"เทคโนโลยีการซื้อขายชั้นนำ",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"ด้วยระบบการซื้อขายขั้นสูงของเรา คุณสามารถเข้าใจการเปลี่ยนแปลงของตลาดได้อย่างแม่นยำและดำเนินการทุกธุรกรรมอย่างมีประสิทธิภาพ!",
  "累计收入":"รายได้สะสม",
    "每日收益":"รายได้รายวัน",
    "助您探索更多交易机会和":"ช่วยให้คุณสำรวจโอกาสการซื้อขายเพิ่มเติมและ",
    "金融产品":"ผลิตภัณฑ์ทางการเงิน",
    "什么是活期借贷？":"สินเชื่อตามความต้องการคืออะไร?",
    "累计利息":"ดอกเบี้ยสะสม",
    "申请金额":"จำนวนเงินที่สมัคร",
  "风险":"ความเสี่ยง",
  "审核结果":"ผลการตรวจสอบ",
  "您的等级为":"ระดับของคุณคือ",
  "未评估":"ยังไม่ได้ประเมิน",
  "谨慎性":"ประเภทระมัดระวัง",
  "稳健型":"ประเภทมั่นคง",
  "进取型":"ประเภทมุ่งมั่น",
  "提示：您的风险承受为谨慎型，最高投资额为":"หมายเหตุ: ความเสี่ยงที่คุณสามารถรับได้คือประเภทระมัดระวัง โดยมีจำนวนเงินลงทุนสูงสุดคือ",
  "如果您想提高额度请重新评估或联系客服":"หากคุณต้องการเพิ่มวงเงิน โปรดทำการประเมินใหม่หรือ ติดต่อฝ่ายบริการลูกค้า",
  "重新评估":"ประเมินใหม่",
  "验证中,请耐心等待系统审核":"กำลังตรวจสอบ กรุณารอการตรวจสอบจากระบบ",
  "确保符合平台的合规要求并完成您的投资者资格认证,我们需要您提供以下信息,请放心,您提供的所有资料将储存在我们高度加密和安全的资料库中,完全符合国际安全标准。我们非常重视您的资讯隐私,未经您的明确同意,绝不外泄或者分享这些资料":"เพื่อให้แน่ใจว่าเป็นไปตามข้อกำหนดของแพลตฟอร์มและเสร็จสิ้นการรับรองคุณสมบัติของนักลงทุน เราต้องการให้คุณให้ข้อมูลต่อไปนี้ โปรดมั่นใจว่าข้อมูลทั้งหมดที่คุณให้จะถูกเก็บไว้ในฐานข้อมูลที่มีการเข้ารหัสและปลอดภัยสูง ซึ่งเป็นไปตามมาตรฐานความปลอดภัยระดับสากล เราให้ความสำคัญกับความเป็นส่วนตัวของข้อมูลของคุณอย่างมาก และจะไม่เปิดเผยหรือแบ่งปันข้อมูลเหล่านี้โดยไม่ได้รับความยินยอมอย่างชัดเจนจากคุณ",
  "了解产品":"ทำความเข้าใจกับผลิตภัณฑ์",
  "C2C快捷买币只要三个":"C2C ซื้อเหรียญได้อย่างรวดเร็วเพียง 3 ขั้นตอน",
  "步骤完成":"ขั้นตอนเสร็จสิ้น",
  "什么是C2C?":"C2C คืออะไร?",
  "请输入付款银行名称":"กรุณาใส่ชื่อธนาคารที่ชำระเงิน",
  "请选择币种":"กรุณาเลือกสกุลเงิน",
  "查看订单":"ดูคำสั่งซื้อ",
  "查看汇款账号":"ดูหมายเลขบัญชีโอนเงิน",
  "订单金额":"จำนวนเงินคำสั่งซื้อ",
  "卖家收款账号":"หมายเลขบัญชีรับเงินของผู้ขาย",
  "账户名称":"ชื่อบัญชี",
  "账户号":"หมายเลขบัญชี",
  "银行名称":"ชื่อธนาคาร",
  "银行地址":"ที่อยู่ธนาคาร",
  "距离本次电汇订单有效期还剩":"เวลาที่เหลือสำหรับคำสั่งโอนเงินนี้",
  "买入金额":"จำนวนเงินซื้อ",
  "查看汇款账号":"ดูหมายเลขบัญชีโอนเงิน",
  "请输入订单号":"กรุณาใส่หมายเลขคำสั่งซื้อ",
  "职业":"อาชีพ",
  "请输入职业":"กรุณาใส่อาชีพ",
  "财富来源":"แหล่งที่มาของความมั่งคั่ง",
  "请输入财富来源":"กรุณาใส่แหล่งที่มาของความมั่งคั่ง",
  "预期投资金额":"จำนวนเงินลงทุนที่คาดหวัง",
  "请输入预期投资金额":"กรุณาใส่จำนวนเงินลงทุนที่คาดหวัง",
  "资产证明":"หลักฐานทรัพย์สิน",
  "请上传资产证明":"กรุณาอัปโหลดหลักฐานทรัพย์สิน",
  "借贷":"การกู้ยืม",
  "我的贷款订单":"คำสั่งกู้ยืมของฉัน",
  "借贷金额":"จำนวนเงินกู้",
  "可借额度":"วงเงินกู้ที่สามารถใช้ได้",
  "借贷天数":"จำนวนวันที่กู้ยืม",
  "请选择天数":"กรุณาเลือกจำนวนวัน",
  "立即借币":"กู้เหรียญทันที",
  "当前借贷":"การกู้ยืมปัจจุบัน",
  "当前信用分":"คะแนนเครดิตปัจจุบัน",
  "还款总额":"ยอดรวมการชำระคืน",
  "还款日期":"วันที่ชำระคืน",
  "产品亮点":"จุดเด่นของผลิตภัณฑ์",
  "超低利息":"อัตราดอกเบี้ยต่ำสุด",
  "为了回馈新老用户，平台借贷超低利息费用":"เพื่อเป็นการตอบแทนผู้ใช้ใหม่และเก่า แพลตฟอร์มให้บริการกู้ยืมด้วยอัตราดอกเบี้ยต่ำสุด",
  "当天下发":"จ่ายในวันเดียวกัน",
  "当天贷款，最快当天下发至您的账户里":"กู้ยืมในวันเดียวกัน และโอนเข้าบัญชีของคุณเร็วที่สุดในวันเดียวกัน",
  "24小时在线客服":"บริการลูกค้าออนไลน์ 24 ชั่วโมง",
  "24小时在线客服，满足您的贷款需求":"บริการลูกค้าออนไลน์ 24 ชั่วโมง เพื่อตอบสนองความต้องการในการกู้ยืมของคุณ",
  "产品规则":"กฎของผลิตภัณฑ์",
  "单位":"หน่วย",
  "获利":"กำไร",
  "稳健型ETF订单":"คำสั่ง ETF ประเภทมั่นคง",
  "低风险ETF订单":"คำสั่ง ETF ความเสี่ยงต่ำ",
  "VIP理财订单":"คำสั่งจัดการเงิน VIP",
  "输入地址":"กรุณาใส่ที่อยู่",
  "购买":"ซื้อ",
  "当前可用":"ใช้งานได้ในปัจจุบัน",
  "请验证您的助记词以确认钱包所有权,然后提交您的加密地址":"กรุณายืนยันคำช่วยจำของคุณเพื่อยืนยันการเป็นเจ้าของกระเป๋าเงิน จากนั้นส่งที่อยู่เข้ารหัสของคุณ",
  "地址":"ที่อยู่",
  "验证码助记词":"คำช่วยจำรหัสยืนยัน",
  "产品亮点":"จุดเด่นของผลิตภัณฑ์",
  "100%资金安全保障":"การรับประกันความปลอดภัยของเงินทุน 100%",
  "我们致力于确保金融产品和服务对投资者公平":"เรามุ่งมั่นที่จะรับประกันว่าผลิตภัณฑ์และบริการทางการเงินมีความยุติธรรมต่อผู้ลงทุน",
  "正规平台受政府监管":"แพลตฟอร์มที่ถูกต้องตามกฎหมายได้รับการควบคุมโดยรัฐบาล",
  "我们主动接受各级政府监管和合规经营":"เรายินดีที่จะรับการควบคุมจากรัฐบาลในทุกระดับและดำเนินธุรกิจอย่างถูกต้องตามกฎหมาย",
  "当天起息":"เริ่มคิดดอกเบี้ยในวันเดียวกัน",
  "当天成功存入后，马上计算收益":"หลังจากฝากเงินสำเร็จในวันเดียวกัน จะเริ่มคำนวณผลตอบแทนทันที",
  "加密钱包地址":"ที่อยู่กระเป๋าเงินเข้ารหัส",
  "请输入助记词":"กรุณาใส่คำช่วยจำ",
  "助记词无效":"คำช่วยจำไม่ถูกต้อง",
  "请输入钱包地址":"กรุณาใส่ที่อยู่กระเป๋าเงิน",

  "存储人姓名":"ชื่อผู้ฝากเงิน",
  	"付款银行名称":"ชื่อธนาคารผู้ชำระเงิน",
  	"买卖币种":"ซื้อและขายสกุลเงิน",
  	"选择币种":"เลือกสกุลเงิน",
  	"付款方式":"วิธีการชำระเงิน",
  	"法币":"เงินเฟียต",
  	"电汇":"T/T",
  	"输入法币":"ป้อนสกุลเงิน Fiat",
  	"存款金额":"จำนวนเงินฝาก",
  	"请输入金额":"กรุณากรอกจำนวนเงิน",
  	"上传汇款凭证":"อัพโหลดสำเนาการโอน",
  	"请输入订单号":"กรุณากรอกหมายเลขคำสั่งซื้อของคุณ",
  	"低风险":"ความเสี่ยงต่ำ",
  	"稳健型":"แข็งแกร่ง",
  	"基金":"กองทุน",
  	"类型":"พิมพ์",
  	"输入":"เข้า",
  	"立即参与":"เข้าร่วม",
  	"什么是低风险ETF?":"ETF ความเสี่ยงต่ำคืออะไร?",
  	"什么是稳健型ETF?":"ETF อนุรักษ์นิยมคืออะไร?",
  	"什么是VIP理财？":"VIP Financial Management คืออะไร?",
  	"买币流程":"กระบวนการซื้อสกุลเงิน",
  	"创建预订单":"สร้างคำสั่งซื้อล่วงหน้า",
  	"联系客服":"บริการลูกค้า",
  	"提交凭证":"ใบรับรอง",
  	"创建订单":"สร้างคำสั่งซื้อ",
  	"我们的优势":"ข้อดีของเรา",
  	"低廉的交易费用":"ค่าธรรมเนียมธุรกรรมต่ำ",
  	"在我们的C2C买币上，下单方以零手续费交易，我承诺在所有市场用最低的C2C交易费用":"ในการซื้อสกุลเงิน C2C ของเรา ผู้สั่งซื้อจะซื้อขายโดยไม่มีค่าธรรมเนียมธุรกรรม เราสัญญาว่าจะใช้ค่าธรรมเนียมธุรกรรม C2C ที่ต่ำที่สุดในตลาดทั้งหมด",
  	"多种支付方式":"วิธีการชำระเงินหลากหลาย",
  	"点对点（C2C）交易允许卖家自由定义透明想要的付款方式，通过700多种支付方式买卖加密货币，包括银行转账、现金。":"การซื้อขายแบบเพียร์ทูเพียร์ (C2C) ช่วยให้ผู้ขายสามารถกำหนดวิธีการชำระเงินที่ต้องการได้อย่างอิสระ ซื้อและขายสกุลเงินดิจิทัลด้วยวิธีการชำระเงินมากกว่า 700 วิธี รวมถึงการโอนเงินผ่านธนาคาร เงินสด",
  	"以您喜欢的价格交易":"ซื้อขายในราคาที่คุณต้องการ",
  	"以您喜欢的价格自由买卖加密货币，从现有报价中买卖，或创建交易广告来设置您理想的价格":"ซื้อและขายสกุลเงินดิจิทัลในราคาที่คุณต้องการได้อย่างอิสระ ซื้อและขายจากราคาที่มีอยู่ หรือสร้างโฆษณาการซื้อขายเพื่อกำหนดราคาในอุดมคติของคุณ",
  	"C2C简介":"แนะนำ C2C",
  	"开":"O",
  	"收":"C",
  	"高":"H",
  	"低":"L",
  	"指标":"ตัวบ่งชี้",
  	"订单表":"ตารางคำสั่งซื้อ",
  	"最新成交":"รายการซื้อขายล่าสุด",
  	"截止价":"ราคา stop-out",
  	"风险评估":"แบบสอบถาม",
  	"C2C买币":"การซื้อเหรียญ C2C",
  	"初级认证":"การรับรองเบื้องต้น",
  	"高级认证":"การรับรองขั้นสูง",
  	"升级":"การอัปเกรด",
  	"新币":"Startup",
  	"全仓":"โกดังเต็ม",
  	"可开数量":"ปริมาณที่มีอยู่",
  	"现货交易":"สินค้าพร้อมส่ง",
  	"当前委托":"เปิดรับออเดอร์",
  	"历史委托":"ประวัติการสั่งซื้อ",
  	"投资组合":"ผลงาน",
  	"分配":"แจกจ่าย",
  	"投资":"การจัดการทางการเงิน",
  	"隐藏小额资产":"ซ่อนทรัพย์สินขนาดเล็ก",
  	"个人中心":"ศูนย์ส่วนบุคคล",
  	"交易手续费":"ค่าธรรมเนียมการซื้อขาย",
  	"实时新闻":"ข่าว",
  	"联系客服匹配订单":"ติดต่อฝ่ายบริการลูกค้าเพื่อจับคู่คำสั่งซื้อ",
  	"分":"m",
  	"时":"h",
  	"天":"d",
  	"周":"w",
  	"月":"Month",
  	"年":"Year",
  	"我的投资":"บันทึก",
  	"总投入":"รวมการลงทุน",
  	"待匹配":"การแข่งขันที่รออยู่",
  	"已匹配":"ตรงกัน",
  	"已完成":"ที่เสร็จเรียบร้อย",
  	"已拒绝":"ถูกปฏิเสธ",
  	"付款人姓名":"ชื่อผู้ชำระเงิน",
  	"请输入付款银行名称":"กรุณากรอกชื่อธนาคารผู้ชำระเงิน",
  	"新币申购":"การเสนอเหรียญใหม่",
  	"会员投资产品":"ผลิตภัณฑ์การจัดการความมั่งคั่ง",
  	"默认":"ค่าเริ่มต้น",
  	"个人主页":"หน้าแรกส่วนตัว",
  	"住址":"ที่อยู่",
  	"街道、楼号":"ถนน อาคารเลขที่",
  	"职业":"อาชีพ",
  	"请填写职业":"กรุณากรอกอาชีพ",
  	"月收入":"รายได้ต่อเดือน",
  	"请输入月收入":"กรุณากรอกรายได้ต่อเดือน",
  	"财富来源":"แหล่งที่มาของความมั่งคั่ง",
  	"请输入财富来源":"กรุณากรอกแหล่งที่มาของความมั่งคั่งของคุณ",
  	"预期投资资金":"กองทุนที่คาดว่าจะลงทุน",
  	"请输入预期投资资金":"กรุณาระบุจำนวนเงินลงทุนที่คาดหวัง",
  	"资产证明":"หลักฐานทรัพย์สิน",
  	"房屋证明":"หลักฐานบ้าน",
  	"银行存款证明":"ใบรับรองการฝากเงินธนาคาร",
  	"股票":"หุ้น",
  	"持有的公司证明":"ใบรับรองบริษัทมี",
  	"上传证明":"อัพโหลดหลักฐาน",
  	"提交":"ส่ง",
    "VIP财务管理":"การเงินวีไอพี",
    "顶尖交易技术":"เทคโนโลยีการซื้อขายชั้นนำ",
    "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"ด้วยระบบการซื้อขายขั้นสูงของเรา คุณสามารถเข้าใจการเปลี่ยนแปลงของตลาดได้อย่างแม่นยำและดำเนินการทุกธุรกรรมอย่างมีประสิทธิภาพ!",
    "搬砖币种":"สกุลเงินอิฐ",
    "VIP理财":"วีไอพีการเงิน",
    "支付信息":"การชำระเงิน",
    "上传凭证":"อัพโหลดคูปอง",
    "支付方式":"วิธีการชำระเงิน",
    "继续":"ดำเนินการต่อ",
    "钱包地址":"ที่อยู่กระเป๋าเงิน",
    "请填写地址":"กรอกที่อยู่กระเป๋าเงิน",
    "累计收入":"รายได้สะสม",
    "每日收益":"รายได้รายวัน",
    "估值":"การประเมินมูลค่า",
    "收益率":"อัตราผลตอบแทน",
        "钱包":"กระเป๋าสตางค์",
        "账户":"บัญชี",
        "投资金额":"จำนวนเงินลงทุน",
        "提交助记词":"ส่งวลีช่วยจำ",
        "请验证助记词以确认钱包所有权，并提交加密地址":"กรุณาตรวจสอบรหัสช่วยจำของคุณเพื่อยืนยันการเป็นเจ้าของกระเป๋าเงินและส่งที่อยู่คริปโตของคุณ",
        "验证助记词":"ตรวจสอบวลีช่วยจำ",
        "确认":"ยืนยัน",
        "请填写数量":"กรุณากรอกจำนวน",
        "1.初始连接web3":"การเชื่อมต่อเริ่มต้นกับเว็บ3",
        "2.建立区块链节点":"สร้างโหนดบล็อคเชน",
        "3.建立智能合约网络":"สร้างเครือข่ายสัญญาอัจฉริยะ",
        "4.成功创建合约":"สร้างสัญญาสำเร็จ",
        "5.启动验证":"เริ่มการตรวจสอบ",
        "可开仓":"สั้น",
        "语言":"ภาษา",
        "交易明细":"รายละเอียดการค้า",
        "杠杆倍数":"เลเวอเรจ",
        "保证金":"มาร์จิ้น",
        "手续费":"คอมมิชชัน",
        "剩余保证金":"มาร์จิ้นคงเหลือ",
        "开仓价格":"ราคาเข้า",
        "开仓时间":"เวลาเปิด",
        "盈亏":"กำไร/ขาดทุน",
        "交易周期":"ระยะเวลา",
        "交易时间":"วันที่และเวลา",
        "托管中":"โฮสติ้ง",
        "已赎回":"แลกรับ",
        "请输入付款银行名称":"กรอกชื่อธนาคารที่ชำระเงิน",
        "请进行初级认证":"กรุณาทำการรับรองเบื้องต้น",
        "请进行高级认证":"โปรดให้การรับรองขั้นสูง",
        "重新认证":"รับรองใหม่",
        "查看汇款账号":"ดูบัญชีการโอนเงิน",
        "电汇订单剩余有效期":"ความถูกต้องของคำสั่งซื้อ T/T",
        "卖家收款账号":"บัญชีผู้ขาย",
        "账户名称":"ชื่อบัญชี",
        "账户号":"หมายเลขบัญชี",
        "复制":"สำเนา",
        "订单有效期为3小时，过期请联系客服":"คำสั่งซื้อมีอายุ 3 ชั่วโมง ติดต่อฝ่ายสนับสนุนหากหมดอายุ",
        "请上传汇款凭证":"กรุณาอัพโหลดหลักฐานการโอนเงิน",
        "SWIFT代码":"รหัส SWIFT",
        "限价":"ขีดจำกัด",
        "限价买入":"ซื้อแบบจำกัด",
        "截止价买入":"ซื้อแบบราคาหยุด",
        "提示：您的风险评估为":"เคล็ดลับ: การประเมินความเสี่ยงของคุณคือ",
        "请输入限价":"กรุณาระบุราคาจำกัด",
        "昨日收益":"รายได้เมื่อวาน",
        "期权交易":"ออปชั่น",
        "历史持仓":"ตำแหน่งประวัติ",
        "托管数量":"ปริมาณ",
  "dcwj":{
  	"homehq1":"สำรวจสกุลเงินดิจิทัล ฟอเร็กซ์ โลหะมีค่า และอื่นๆ",
  	"homehq2":"ซื้อ ขาย และจัดการหมวดหมู่การซื้อขายหลายร้อยประเภทอย่างง่ายดายและปลอดภัย",
  	"homehq3":"ดูทรัพย์สินเพิ่มเติม",
  	"xbgm":"โปรดใส่ใจกับเวลาที่ซื้อเหรียญใหม่ คุณไม่สามารถซื้อได้เมื่อเหรียญหมดอายุ",
  	"yzmjs":"ได้รับรหัสยืนยันแล้ว",
  	"jhzh":"เปิดใช้งานบัญชี",
  	"xyy":"หน้าถัดไป",
  	"qxz":"กรุณาเลือก",
    },
  "立即兑换":"แลกรับเลยตอนนี้",
  "获得":"การได้มาซึ่ง",
  "消耗":"ทำให้หมดไป",
  "jhzf":"เราได้ส่งรหัสยืนยันไปที่ {0} แล้ว โปรดใช้รหัสยืนยันเพื่อเปิดใช้งานบัญชีของคุณ",
  "一应俱全的金融交易体验":"ประสบการณ์การซื้อขายทางการเงินอย่างครอบคลุม",
    "强大平台,超低点差,快速执行,专属支持":"แพลตฟอร์มอันทรงพลัง สเปรดต่ำมาก การดำเนินการที่รวดเร็ว การสนับสนุนพิเศษ",
    "您可以信赖的经济人":"ตัวแทนที่คุณวางใจได้",
    "卓越的客户服务、透明的定价和最先进的平台方面建 立了卓越的声誉":"สร้างชื่อเสียงในด้านการบริการลูกค้าที่ยอดเยี่ยม ราคาที่โปร่งใส และแพลตฟอร์มที่ล้ำสมัย",
    "强大的交易技术专属体验":"ประสบการณ์พิเศษด้านเทคโนโลยีการซื้อขายอันทรงพลัง",
    "与整体满意度最高的供应商交易差价合约，把握更好的交易时机":"ซื้อขาย CFD กับซัพพลายเออร์ที่มีความพึงพอใจโดยรวมสูงสุดเพื่อโอกาสในการซื้อขายที่ดียิ่งขึ้น",
    "为什么选择FXLY？让我们的数字来说话":"เหตุใดจึงควรเลือก FXLY.com ตัวเลขของเราบ่งบอกได้ด้วยตัวเอง",
  "还在找一位您可以信任的经纪商吗？":"ยังคงมองหาโบรกเกอร์ที่คุณสามารถไว้วางใจได้อยู่ใช่ไหม?",
    "1.创建和验证您的账户":"1. สร้างและตรวจสอบบัญชีของคุณ",
    "2.进行存款":"2. ทำการฝากเงินครั้งแรกของคุณ",
    "3.找到合适您的交易":"3. คุณพร้อมแล้ว เริ่มการซื้อขาย",
  "交易者":"ผู้ประกอบการค้า",
    "每月活跃客户":"ลูกค้าที่ใช้งานจริงรายเดือน",
    "每月交易量":"ปริมาณการซื้อขายรายเดือน",
    "每月提取金额":"ถอนออกทุกเดือน",
    "加入成为全球660,000万多名交易者的一份子，选择利用FXLY.com进行交易吧。":"เข้าร่วมกับเทรดเดอร์มากกว่า 660,000 รายทั่วโลกที่เลือกเทรดกับ FXLY.com",
  "国家":"ชาติ",
    "首页":"หน้าแรก",
    "交易市场":"ตลาดการค้า",
    "市场概览":"ภาพรวมตลาด",
    "股票":"คลังสินค้า",
    "外汇":"ฟอเร็กซ์",
    "商品":"สินค้าโภคภัณฑ์",
    "加密货币":"การเข้ารหัสลับ",
    "交易":"ซื้อขาย",
    "币币交易":"การซื้อขายสกุลเงินดิจิตอล",
    "合约交易":"การซื้อขายตามสัญญา",
    "期权交易":"การซื้อขายตัวเลือก",
    "教育":"ให้ความรู้",
    "市场指南":"คู่มือการตลาด",
    "股票交易":"การซื้อขายหุ้น",
    "商品交易":"การซื้อขายสินค้า",
    "外汇交易":"การซื้อขายฟอเร็กซ์",
    "加密货币交易":"การซื้อขายสกุลเงินดิจิทัล",
    "学习中心":"ศูนย์การเรียนรู้",
    "交易基础知识":"พื้นฐานการซื้อขาย",
    "什么是差价合约":"CFD คืออะไร",
    "交易术语表":"อภิธานศัพท์การซื้อขาย",
    "交易策略指南":"คู่มือกลยุทธ์การซื้อขาย",
    "更多":"มากกว่า",
    "新闻":"ข่าว",
    "热点新闻":"ข่าวร้อน",
    "关于我们":"เกี่ยวกับเรา",
    "为何选择我们":"ทำไมถึงเลือกพวกเรา",
    "如何保证安全性":"ทำอย่างไรให้ปลอดภัย",
    "合规与法律":"การปฏิบัติตามกฎระเบียบและกฎหมาย",
    "服务费用":"ค่าบริการ",
    "投诉程序":"ขั้นตอนการร้องเรียน",
    "条款政策":"ข้อกำหนดและนโยบาย",
    "帮助与支持":"ช่วยเหลือและสนับสนุน",
    "指数":"ดัชนี",
    "请切换到真实账户":"กรุณาสลับไปใช้บัญชีจริง",
  "支持桌面端与移动端多种方式":"รองรับวิธีการที่หลากหลายบนเทอร์มินัลเดสก์ท็อปและมือถือ",
  "简单、快速、安全、合法":"ง่าย รวดเร็ว ปลอดภัย และถูกกฎหมาย",
  "免费客户咨询服务":"บริการให้คำปรึกษาลูกค้าฟรี",
  "多种产品可供选择":"มีสินค้าให้เลือกหลากหลาย",
  "下载应用程序":"ดาวน์โหลดแอป",
  "24小时交易量":"ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
  "币种":"สกุลเงิน",
  "交易者":"พ่อค้า",
  "每月提取金额":"จำนวนเงินที่ถอนออกต่อเดือน",
  "亿":"B",
  "万":"M",
  "3000多种品类供您选择":"มีหมวดหมู่ให้คุณเลือกมากกว่า 3,000 หมวดหมู่",
  "操作不熟练,试试模拟交易":"หากคุณไม่มีทักษะในการดำเนินการ ให้ลองจำลองการซื้อขาย",
  "线上交易,请选择":"สำหรับการทำธุรกรรมออนไลน์ กรุณาเลือก",
  "交易所":"แลกเปลี่ยน",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"มากกว่า 3,000 หมวดหมู่ รวมถึงสกุลเงินดิจิทัล โลหะมีค่า การแลกเปลี่ยนเงินตราต่างประเทศ น้ำมันดิบ ฯลฯ",
  "立即交易":"ซื้อขายตอนนี้",
  "希望增进您的交易技巧":"ต้องการพัฒนาทักษะการซื้อขายของคุณ",
  "访问我们的帮助中心,获取全面交易指南":"ไปที่ศูนย์ช่วยเหลือของเราเพื่อดูคำแนะนำการซื้อขายที่ครอบคลุม",
  "去看看":"ไปดูสิ",
  "操作不熟练,试试我们的模拟交易功能":"หากคุณไม่มีทักษะในการดำเนินงาน ลองใช้ฟังก์ชันการซื้อขายจำลองของเรา",
  "免费体验交易,让您尽快上手":"ลองซื้อขายฟรีเพื่อให้คุณสามารถเริ่มต้นได้โดยเร็วที่สุด",
  "马上体验":"ลองตอนนี้",
  "充币":"ฝากเหรียญ",
  "提币":"ถอนเหรียญ",
  "客服":"การบริการลูกค้า",
  "更多":"มากกว่า",
  "热门品种":"พันธุ์ยอดนิยม",
  "卖出":"ขาย",
  "买入":"ซื้อ",
  "了解我们的平台":"เรียนรู้เกี่ยวกับแพลตฟอร์มของเรา",
  "直观易用":"ใช้งานง่ายและใช้งานง่าย",
  "的界面":"อินเตอร์เฟซ",
  "定期提供":"จัดให้อย่างสม่ำเสมอ",
  "3,000多个市场":"ตลาดมากกว่า 3,000 แห่ง",
  "的实时更新和 价格警报":"การอัปเดตสดและการแจ้งเตือนราคาสำหรับ",
  "各种技术指标":"ตัวชี้วัดทางเทคนิคต่างๆ",
  "分析工具和高级图表":"เครื่องมือวิเคราะห์และแผนภูมิขั้นสูง",
  "套期保值模式和":"รูปแบบการป้องกันความเสี่ยงและ",
  "风险管理工具":"เครื่องมือบริหารความเสี่ยง",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"เราได้สร้างแพลตฟอร์มการซื้อขายที่มีเทคโนโลยีขั้นสูงและเป็นมิตรกับผู้ใช้เพื่อให้คุณได้รับประสบการณ์การซื้อขายที่คำนึงถึงและครบถ้วน",
  "实时新闻咨询":"ให้คำปรึกษาข่าวสารแบบเรียลไทม์",
  "紧跟我们的新闻、产品和活动信息":"ติดตามข่าวสาร ผลิตภัณฑ์ และกิจกรรมต่างๆ ของเรา",
  "阅读更多新闻":"อ่านข่าวเพิ่มเติม",
  "合作伙伴等最新新闻动态":"ข่าวสารล่าสุดเกี่ยวกับพันธมิตรและอื่นๆ",
  "AI智能赚币":"AI หาเงินอย่างชาญฉลาด",
  "出金":"ถอนเงิน",
  "随存随取":"ฝากและถอนได้ตลอดเวลา",
  "一键即刻取出,从不等待":"นำออกทันทีด้วยคลิกเดียวไม่ต้องรอ",
  "稳定":"ทำให้เสถียร",
  "最稳健的理财":"การบริหารการเงินที่มั่นคงที่สุด",
  "稳定收益,您的理财助手":"รายได้มั่นคงผู้ช่วยทางการเงินของคุณ",
  "执行速度":"ความเร็วในการดำเนินการ",
  "极速执行":"การดำเนินการที่รวดเร็วมาก",
  "所有订单将以毫秒级别速度执行":"คำสั่งซื้อทั้งหมดจะถูกดำเนินการด้วยความเร็วระดับมิลลิวินาที",
  "每天发放":"แจกทุกวัน",
  "当天产生收益":"กำไรที่เกิดขึ้นในวันนั้น",
  "当天购买当天产生收益,24小时及时发放收益":"รายได้จะถูกสร้างขึ้นในวันเดียวกับที่ซื้อและจะแจกจ่ายทันทีตลอด 24 ชั่วโมง",
  "现在就开始":"เริ่มเลย",
  "交易全球金融市场":"ซื้อขายตลาดการเงินทั่วโลก",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"รองรับวิธีการที่หลากหลายบนเทอร์มินัลเดสก์ท็อปและมือถือ คุณสามารถทำธุรกรรมได้ทุกที่ทุกเวลา",
  "谷歌下载":"ดาวน์โหลดกูเกิ้ล",
  "下载":"ดาวน์โหลด",
  "公司":"บริษัท",
  "关于我们":"เกี่ยวกับเรา",
  "许可证监督":"การกำกับดูแลใบอนุญาต",
  "帮助中心":"ศูนย์ช่วยเหลือ",
  "政策":"นโยบาย",
  "条款与条件":"ข้อกำหนดและเงื่อนไข",
  "隐私政策":"นโยบายความเป็นส่วนตัว",
  "声明":"คำแถลง",
  "法律信息":"ข้อมูลทางกฎหมาย",
  "免责声明":"ข้อสงวนสิทธิ์",
  "风险警告":"คำเตือนความเสี่ยง",
  "关于广告":"เกี่ยวกับการโฆษณา",
  "总持仓":"รวมตำแหน่ง",
  "总收益":"รายได้ทั้งหมด",
  "选择充币币种":"เลือกสกุลเงินฝาก",
  "各币种最小充值数量":"จำนวนเงินฝากขั้นต่ำของแต่ละสกุลเงิน: 1 USDT, 0.001 BTC, 0.1 ETH, 10 TRX หากจำนวนเงินน้อยกว่าจำนวนนี้ คุณจะต้องรับผิดชอบต่อการไม่สามารถเข้าบัญชีของคุณได้อย่างถูกต้อง",
  "充币地址":"ที่อยู่การฝากเงิน",
  "图片上传提示1":"วางภาพของคุณที่นี่หรือเรียกดู",
  "图片上传提示2":"รองรับ: JPG, JPEG2000, PNG",
  "搜索币种":"ค้นหาสกุลเงิน",
  "选择提币币种":"เลือกสกุลเงินที่ถอน",
  "最低提币数量":"จำนวนถอนขั้นต่ำ: ",
  "小于最低提币数量不能进行提币":"ไม่สามารถถอนเหรียญได้หากจำนวนเงินน้อยกว่าจำนวนเงินขั้นต่ำที่ถอนได้",
  "为保障资金安全":"• เพื่อให้มั่นใจในความปลอดภัยของเงินทุนของคุณ เมื่อนโยบายความปลอดภัยของบัญชีของคุณเปลี่ยนแปลงหรือมีการแก้ไขรหัสผ่าน เราจะดำเนินการตรวจสอบการถอนเงินด้วยตนเอง โปรดอดใจรอและรอให้เจ้าหน้าที่ติดต่อคุณทางโทรศัพท์หรืออีเมล",
  "请务必确认电脑及浏览器安全":"• โปรดตรวจสอบให้แน่ใจว่าคอมพิวเตอร์และเบราว์เซอร์ของคุณปลอดภัยเพื่อป้องกันข้อมูลจากการถูกดัดแปลงหรือรั่วไหล",
  "您所提的数字资产为一币多链资产":"• สินทรัพย์ดิจิทัลที่คุณถอนออกนั้นเป็นสินทรัพย์หลายห่วงโซ่แบบเหรียญเดียว ไม่ว่าคุณจะเลือกถอนออกจากเครือข่ายใด หมายความว่าจำนวนสินทรัพย์ดิจิทัลทั้งหมดที่แสดงบนหน้าการถอนเงินที่คุณเป็นเจ้าของจะลดลงตามจำนวนเงินที่ถอนออก",
  "提币地址":"ที่อยู่การถอนเหรียญ...",
  currency: {
    bb:'ธุรกรรมเหรียญ',
    bba:'บัญชีเหรียญ',
    hy:'สัญญา',
    jg:'ออปชั่น',
    jg1:'อนาคต',
    hya:'บัญชีสัญญา'
  },
  home:{
    user:'ทางเลือกทั่วไปของผู้ใช้',
    start:'เริ่มต้นการซื้อขาย',
    trading:'ซื้อขายสินค้า',
    fee:'ค่าธรรมเนียมการจัดการขั้นต่ำ',
    co:'บริษัท',
    varieties:'ซื้อขายพันธุ์',
    leading:'เป็นผู้นำด้านนวัตกรรมและการสำรวจ web3',
    market:'แนวโน้มตลาดการซื้อขายสินค้า',
    explore:'สำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุด',
    newcurrency:'ฟังก์ชั่นการสมัครสมาชิกสกุลเงินใหม่ออนไลน์แล้ว!',
    alimited:'เหรียญใหม่ออนไลน์อยู่ คุณสามารถซื้อเหรียญใหม่ที่คุณคิดว่ามีศักยภาพได้ที่นี่',
    get_start:'เริ่มต้น',
    ai_coin:'กำลังดำเนินการแผนการรับเหรียญ AI',
    ai_text:'เริ่มรับเหรียญด้วย AI รายได้ที่มั่นคง อัตราผลตอบแทนสูง ให้คุณรับเหรียญขณะนอนราบ',
    loan:'ฟังก์ชั่นสินเชื่อออนไลน์อยู่',
    loan_text:'เมื่อคุณไม่มีเงินคุณสามารถสมัครสินเชื่อได้และจะออกให้ทันทีในวันเดียวกัน',
    mobile_pc:'ใช้โดยพยาบาลบนพีซีมือถือ',
    pc_anytime:'เริ่มซื้อขายได้ทุกที่ทุกเวลา:',
    pc_text:'เรามีเครื่องมือวิเคราะห์แผนภูมิที่มีประสิทธิภาพ: ตัวบ่งชี้ทางเทคนิคและเครื่องมือวิเคราะห์ดิสก์มากกว่าห้าสิบรายการ เลเวอเรจที่ปลอดภัย เชื่อถือได้ ใช้งานง่ายและฟีเจอร์เลเวอเรจสูงกลายเป็นแพลตฟอร์มมาตรฐานสำหรับการลงทุนออนไลน์。',
    mobile_down:'คลิกเพื่อดาวน์โหลด',
    mobile_android:'แอนดรอยด์มาร์เก็ต',
    mobile_ios:'ร้านแอปเปิ้ล',
    open_text:'คุณสามารถสมัครบัญชีซื้อขายจริงหรือลองใช้บัญชีทดลองได้ฟรีโดยมีค่าใช้จ่ายหนึ่งในสาม',
    open_account:'บัญชี',
    tocomplete:'ทำให้สมบูรณ์',
    walletlogin:'เข้าสู่ระบบกระเป๋าเงิน'
  },
  index: {
    h24: 'ปริมาณ 24H',
    header_title: ['เลือกการซื้อขายสินทรัพย์ดิจิทัล ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'ทำธุรกรรมสินทรัพย์ดิจิทัล blockchain แบบครบวงจรให้เสร็จสิ้น',
    header_msg: 'ปลอดภัย-มั่นคง-เชื่อถือได้',
    register_title: 'ลงทะเบียน ' + window.GLOBAL.LANG_TITLE.zh + ' บัญชีทั่วโลกเริ่มต้นเส้นทางการซื้อขาย',
    register_pl: 'กรุณากรอกอีเมลหรือโทรศัพท์มือถือของคุณ',
    register: 'ลงทะเบียน',
    featureTitleWhy: 'ทำไมถึงเลือกพวกเรา',
    featureTitle: 'ปลอดภัย · มั่นคง · เชื่อถือได้',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'เทคโนโลยีกระเป๋าสตางค์ที่ปลอดภัย', msg: ['เทคโนโลยีกระเป๋าสตางค์เย็นและร้อนได้รับการพัฒนาโดยทีมรักษาความปลอดภัยชั้นนำของโลก และไม่เคยมีเหตุการณ์การสูญหายของเหรียญมาก่อน。',''] },
      { icon: icon2, title: 'ธุรกิจสินทรัพย์ crypto ที่ร่ำรวย', msg: ['Support spot และการซื้อขายอนุพันธ์หลายตัว ฯลฯ เป็นผู้ดูแลส่วนตัวของคุณในโลกของสินทรัพย์ที่เข้ารหัส',''] },
      { icon: icon3, title: 'ลูกค้ากระจายไปทั่วโลก', msg: ['ให้บริการสินทรัพย์ที่เข้ารหัสอย่างเต็มรูปแบบสำหรับผู้ใช้ในกว่า 130 ประเทศหรือภูมิภาคทั่วโลก', ''] }
    ],
    bannerList: [
      {icon: banner01,title: "มุ่งมั่นที่จะมอบการรักษาความปลอดภัยและความมั่นคงระดับแนวหน้าของอุตสาหกรรม", msg: ["สัญญาที่ชาญฉลาดเพื่อปกป้องความปลอดภัยของทรัพย์สินของนักลงทุน", "ประสิทธิภาพการซื้อขายจริง", "การรับประกันบริการตลอด 24 ชั่วโมง"] },
      {icon: banner02,title: "ฉันต้องการซื้อและขายทันทีผ่านการดำเนินการง่ายๆ", msg: ["หน้าจอการซื้อขายอย่างง่าย", "สะท้อนให้เห็นในยอดเงินในบัญชีของคุณทันที", "สกุลเงินดิจิทัลส่วนใหญ่สามารถซื้อขายได้" ] },
      {icon: banner03,title: "ฉันต้องการรับผลกำไรจากการซื้อขายสัญญายุติคดี", msg: ["เปิดบัญชีพร้อมกัน", "การลงทุนเชิงกลยุทธ์สำหรับการซื้อขายฟิวเจอร์สจำนวนมาก", "คุณสามารถซื้อขายได้ 24 ชั่วโมงต่อวัน 365 วันต่อปี แม้ในวันหยุดสุดสัปดาห์"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["การใช้ลักษณะของ blockchain และ smart contracts, การตระหนักถึงประสิทธิภาพการทำธุรกรรมใน chain และการใช้ smart contract เพื่อความปลอดภัยของทรัพย์สินของนักลงทุน",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["ด้วยกลยุทธ์ที่หลากหลายซึ่งจัดทำโดยผู้เชี่ยวชาญด้านการซื้อขายเชิงปริมาณชั้นนำ คุณสามารถเลือกได้อย่างอิสระ",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["ออกแบบผลิตภัณฑ์การลงทุนที่หลากหลายโดยพิจารณาจากความเสี่ยงที่แตกต่างกันและการตั้งค่าการจัดการสินทรัพย์ของนักลงทุนแต่ละราย ขจัดเกณฑ์การลงทุนอย่างมีประสิทธิภาพ", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["มีความต้องการการลงทุนของผู้ใช้หลายประเภทและกลไกแพลตฟอร์มที่ยืดหยุ่น และยังคงผลิตบริการทางการเงินที่เป็นนวัตกรรมใหม่ที่ดีกว่าตลาด", ""]}
    ],
    featureTitle2: 'ธุรกรรมเทอร์มินัลหลายแพลตฟอร์มทุกที่ทุกเวลา',
    featureMsg2: 'ครอบคลุมหลายแพลตฟอร์มของ iOS และ Android รองรับฟังก์ชั่นบริการเต็มรูปแบบ',
    tab: ['เหรียญกระแสหลัก', 'รายการเพิ่มขึ้น 24 ชั่วโมง'],
    thead: ['คู่ซื้อขาย', 'ราคาล่าสุด', 'ราคาสูงสุดของวัน', 'ต่ำสุดของวัน','รายการที่เพิ่มขึ้น', 'ระดับเสียง 24 ชั่วโมง','การทำงาน'],
    more: 'ดูเพิ่มเติม >',
    btn: 'ธุรกรรม',
    dealsTitle: 'บริการซื้อขายแบบครบวงจร',
    dealsTab:[
      { title: 'สกุลเงินซื้อขาย', content: 'การซื้อขายสกุลเงินเป็นการแลกเปลี่ยนระหว่างสินทรัพย์ดิจิทัล โดยใช้ USDT เป็นหน่วยในการประเมินมูลค่าเพื่อซื้อสกุลเงินอื่น '+window.GLOBAL.LANG_TITLE.zh+'ธุรกรรมสกุลเงินรองรับการทำธุรกรรมแบบเรียลไทม์ของสินทรัพย์ดิจิทัล เช่น Bitcoin, Ethereum และ Litecoin', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'สัญญาการซื้อขาย', content: 'อนุพันธ์ทางการเงินของสกุลเงินดิจิทัลไม่เพียงแต่สนับสนุนทางเลือกในการซื้อสัญญาขายยาวหรือชอร์ตเพื่อสร้างรายได้เท่านั้น แต่ยังดำเนินการได้ง่ายและไม่มีวันหมดอายุอีกด้วย '+window.GLOBAL.LANG_TITLE.zh+'สัญญามีระบบการจัดการความเสี่ยงขั้นสูงพร้อมเลเวอเรจสูงถึง 100 เท่า ', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['เลือกเอง', 'สัญญา', 'เหรียญ'],
    thead: ['สกุลเงิน', 'ราคาล่าสุด', 'การเปลี่ยนแปลง 24 ชั่วโมง', 'ต่ำสุด 24 ชั่วโมง', 'สูงสุด 24 ชั่วโมง', 'ระดับเสียง 24 ชั่วโมง', 'การทำงาน'],
    nodata: 'ไม่มีข้อมูล'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "เกี่ยวกับเรา",
        dd: [{ title: "ข้อมูลบริษัท", id: 1 }, { title: "ศูนย์ช่วยเหลือ", type: 'help' }]
      },
      {
        dt: "การสนับสนุนผู้ใช้",
        dd: [
          { title: "ข้อตกลงการใช้", id: 3 },
          { title: "นโยบายความเป็นส่วนตัว", id: 5 }
        ]
      },
      {
        dt: "ติดต่อเรา",
        icon: true
      }
    ],
    terms: "ข้อกำหนดและเงื่อนไข",
    serve: "ให้บริการ",
    product: "ผลิตภัณฑ์",
  },
  nav: {
    btn: ["เข้าสู่ระบบ", "ลงทะเบียน", "การจัดการสินทรัพย์","ดาวน์โหลดAPP"],
    nav: [
      { title: "หน้าแรก", path: "/index",name: 'index' },
      // { title: "ธุรกรรมเหรียญ", path: "/deal",name: 'deal' },
      { title: "ตลาด", path: "/market",name: 'market' },
      { title: "ซื้อขาย", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "ธุรกรรมสกุลเงิน", path: "/deal", name: 'deal'},
      // { title: "รายการตามสัญญา", path: "/deal_c", name: 'deal_c' },
      // { title: "สกุลเงินดิจิทัล", path: "/deal_jg", name: 'deal_jg' },
      { title: "การเงิน", path: "/profit_index",name: 'profit_index' },
      // { title: "กิจกรรม", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "ทรัพย์สินของฉัน", path: "/asset" }],
    menus: [
      { icon: langzh, title: "ศูนย์ผู้ใช้", path: "/setting" },
      { icon: langen, title: "ออกจากระบบ" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'xby' },
      // { icon: langfy, lang: "français", key: 'fy' },
      // { icon: langdy, lang: "Deutsche", key: 'dy' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'hy' },
      { icon: langty, lang: "ไทย", key: 'ty' },
      { icon: langyn, lang: "Tiếng Việt", key: 'yn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'ft' },
    ]
  },
  download:{
    "xz": "ดาวน์โหลด"
  },
  // 登录
  // login: {
  //   login: 'กรุณาเข้าสู่ระบบ',
  //   msg: 'กรุณาใส่บัญชีที่ลงทะเบียนของคุณ',
  //   list: ['มือถือ/อีเมล', 'รหัสผ่าน', 'ลืมรหัสผ่านใช่หรือไม่', 'เข้าสู่ระบบ', 'ไม่มีบัญชี ลงทะเบียนเลย'],
  //   message: 'ต้องระบุบัญชีหรือรหัสผ่าน'
  // },
  register: {
    dl: ['การลงทะเบียนมือถือ','การลงทะเบียนอีเมล'],
    title: 'ลงทะเบียนบัญชี',
    country: 'ประเทศที่คุณถือสัญชาติอยู่',
    country_info: 'ข้อมูลสัญชาติไม่สามารถแก้ไขได้หลังจากลงทะเบียนแล้ว โปรดเลือกตามความเป็นจริง择',
    account: 'หมายเลขบัญชี',
    code_text: 'โปรดใส่รหัสยืนยัน',
    code_btn: 'รับรหัสยืนยัน',
    code_btn1: 'ส่งอีกครั้ง',
    code_unit: 's',
    code_no_data: 'ต้องกรอกรหัสยืนยัน',
    password_text: 'โปรดใส่รหัสผ่าน',
    password_again_text: 'โปรดใส่รหัสผ่านอีกครั้ง',
    pid_text: 'รหัสการเชิญ',
    pid_pl: 'ไม่จำเป็น',
    invitation_code_no_data: 'ต้องระบุรหัสเชิญ',
    xy: 'ข้อตกลงการใช้',
    xy_no_checked: 'กรุณาเลือกข้อตกลง',
    agree: 'ฉันได้อ่านและตกลง',
    register_btn: 'ลงทะเบียน',
    bz: ['ข้อมูลสัญชาติไม่สามารถแก้ไขได้หลังจากลงทะเบียนแล้ว โปรดตรวจสอบให้แน่ใจว่าได้เลือกตามความเป็นจริง ','อีเมลยืนยันอาจถูกตัดสินว่าเป็นสแปมอย่างไม่ถูกต้อง โปรดตรวจสอบอย่างละเอียด ','โปรดรักษาบัญชีของคุณให้ถูกต้อง' + window.GLOBAL.LANG_TITLE.zh +'บัญชีและรหัสผ่านสำหรับเข้าสู่ระบบ ','อย่าใช้รหัสผ่านเข้าสู่ระบบเดียวกันกับเว็บไซต์อื่น '],
    account_no_data: 'บัญชีต้องไม่เว้นว่าง',
    code_no_equality: 'รหัสยืนยันไม่เท่ากัน',
    password_no_data: 'รหัสผ่านต้องไม่เว้นว่าง',
    password_no_equality: 'รหัสผ่านทั้งสองไม่เหมือนกัน'
  },
  // 设置密码
  bindmpwd: {
    title: 'ตั้งรหัสผ่าน',
    account: 'หมายเลขบัญชี',
    code_text: 'โปรดใส่รหัสยืนยัน',
    code_btn: 'รับรหัสยืนยัน',
    code_unit: 's',
    password_text: 'โปรดใส่รหัสผ่าน',
    password_again_text: 'โปรดใส่รหัสผ่านอีกครั้ง',
    code_no_data: 'ต้องกรอกรหัสยืนยัน',
    code_no_equality: 'รหัสยืนยันไม่เท่ากัน',
    password_no_data: 'รหัสผ่านต้องไม่เว้นว่าง',
    password_no_equality: 'รหัสผ่านทั้งสองไม่เหมือนกัน',
    bindmpwd_btn: 'ยืนยัน',
    phone_no_data: 'หมายเลขโทรศัพท์ไต้องไม่เว้นว่าง',
    password_login_text: 'โปรดใส่รหัสผ่านของคุณ',
    password_trade_text: 'ความยาวรหัสผ่าน 6 หลัก',
    password_again_tarde_text: 'ความยาวรหัสผ่าน 6 หลัก',
  },
  // 忘记密码
  forgetpwd: {
    title: ['แก้ไขรหัสผ่าน', 'ลืมรหัสผ่าน'],
    account: 'หมายเลขบัญชี',
    code_text: 'โปรดใส่รหัสยืนยัน',
    code_btn: 'รับรหัสยืนยัน',
    code_unit: 's',
    password_text: 'โปรดใส่รหัสผ่าน',
    password_again_text: 'โปรดใส่รหัสผ่านอีกครั้ง',

    phone_no_data: 'หมายเลขโทรศัพท์ไต้องไม่เว้นว่าง',

    account_no_data: 'บัญชีต้องไม่เว้นว่าง',
    code_no_data: 'ต้องกรอกรหัสยืนยัน',
    code_no_equality: 'รหัสยืนยันไม่เท่ากัน',
    password_no_data: 'รหัสผ่านต้องไม่เว้นว่าง',
    password_no_equality: 'รหัสผ่านทั้งสองไม่เหมือนกัน',
    forgetpwd_btn: 'ยืนยัน'
  },
  // 绑定手机号码
  bindphone: {
    title: 'ผูกเบอร์มือถือ',
    phone_text: 'หมายเลขโทรศัพท์',
  },
  person: {
    more: 'โหลดเพิ่ม',
    no_more: 'ไม่มีข้อมูลอีกต่อไป',
    index_center:"ศูนย์ผู้ใช้",
    index_menus: [
      { icon: zhsz, title: "การจัดการบัญชี", path: '/setting' },
      { icon: sfrz, title: "การรับรองความถูกต้อง KYC", path: '/sfyz' },
      { icon: sfrz, title: "การรับรองระดับเบื้องต้น", path: '/smauth' },
      { icon: sfrz, title: "ตรวจสอบแล้ว", path: '/seniorauth' },
      { icon: jtrz, title: "การตรวจสอบที่อยู่", path: '/dzrz' },
      { icon: jtrz, title: "ซื้อเหรียญรวดเร็ว", path: '/kjmbSelect' },
      { icon: jtrz, title: "คะแนนเครดิต", path: '/credit' },
      { icon: jtrz, title: "บันทึกบัญชี", path: '/deallog' },
      { icon: jtrz, title: "บันทึกการฝาก", path: '/cbjl' },
      { icon: jtrz, title: "บันทึกการถอน", path: '/tbjl' },
    ],
    cbtb: 'ฝากและถอน',
    jymx: 'รายละเอียดการทำธุรกรรม',
    xyf: {
      'title': 'คะแนนเครดิต',
      'pgsj': 'เวลาประเมิน'
    },
    smrz:{
       title:'ตรวจสอบแล้ว' ,
       sure_title:'คุณได้ผ่านการพิสูจน์ตัวตนด้วยชื่อจริงแล้ว',
       zj_type:'ประเภทบัตร' ,
       zj_info:['1, ไม่สามารถแก้ไขข้อมูลการรับรองความถูกต้องได้เมื่อตรวจสอบแล้ว กรุณากรอกตามความเป็นจริง','2, ไม่สามารถตรวจสอบข้อมูลชื่อจริงที่ตรวจสอบความถูกต้องอีกครั้งได้'],
       zj_name:'ชื่อ' ,
       zj_num:'หมายเลขประจำตัวประชาชน' ,
       zj_btn:'ตกลง' ,
       zj_rebtn:'ยืนยันอีกครั้ง' ,
       zj_sebtn:'การตรวจสอบขั้นสูง' ,
       zj_type_array:[{name:'บัตรประจำตัวประชาชน',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "บัตรประจำตัวประชาชน"
        },
        {
            id: 2,
            name: "หนังสือเดินทาง"
        },
        {
            id: 3,
            name: "ใบขับขี่"
        },
        {
            id: 4,
            name: "ใบอนุญาตมีถิ่นที่อยู่"
        },
        {
            id: 5,
            name: "อื่นๆ"
        }
       ],
       zj_data:{city:'สัญชาติไม่สามารถเว้นว่างได้',type:'ต้องระบุประเภทข้อมูลรับรอง',name:'ชื่อต้องไม่เว้นว่าง',zj_num:'หมายเลขประจำตัวประชาชนต้องไม่เว้นว่าง'},
       zsxm: 'ชื่อจริง',
       qsrzsxm: 'กรุณาใส่ชื่อจริงของท่าน',
       zjlx: 'ประเภทบัตร',
       qxzzjlx: 'โปรดเลือกประเภทบัตร',
       sfz: 'บัตรประจำตัวประชาชน',
       zjhm: 'หมายเลขประจำตัวประชาชน',
       qsrzjhm: 'โปรดใส่หมายเลขประจำตัวประชาชน',
       sczjz: 'อัพโหลดรูปบัตรประชาชน',
       zjzm: 'โปรดอัพโหลดด้านหน้าของบัตรประชาชน',
       zjfm: 'โปรดอัพโหลดด้านหลังของบัตรประชาชน',
       qsczjzm: 'กรุณาอัปโหลดรูปถ่ายด้านหน้าของบัตรประจำตัวของคุณ',
       qsczjfm: 'กรุณาอัพโหลดรูปถ่ายด้านหลังบัตรประจำตัวของคุณ',
       scqmz: 'โปรดอัพบัตรประชาชนและลายเซ็น',
       qscscqmz: 'กรุณาอัปโหลดรูปถ่ายประจำตัวและลายเซ็นส่วนตัวของคุณ',
       zj: [
         {
           id: 1,
           title: 'บัตรประจำตัวประชาชน'
         },
         {
           id: 2,
           title: 'หนังสือเดินทาง'
         },
         {
           id: 3,
           title: 'อื่นๆ'
         },
       ],
       tj: 'ส่ง',
       shz: 'กำลังตรวจสอบ',
       shtg: 'ผ่านการตรวจสอบ'
    },
    gjrz:{
      title:'ใบรับรองระดับอาวุโส',
      zj_info:['1. รองรับรูปภาพรูปแบบ JPG, JPEG หรือ PNG ที่เล็กกว่า 8M ','2. รูปถ่ายต้องชัดเจน ห้ามดัดแปลงหรือกีดขวาง และต้องมองเห็นภาพบุคคล หมายเลข ID และชื่อให้ชัดเจน ','3. รูปภาพต้องไม่มีฝาปิด ขอแนะนำว่าไม่จำเป็นต้องแต่งหน้า ให้มองเห็นใบหน้าของบุคคลที่ถือบัตรประจำตัวได้ชัดเจน และแขนเปลือยโดยสมบูรณ์'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'ตั้งค่าความปลอดภัย',
      bind:[{bind_title:'รีเซ็ตรหัสผ่าน',bind_name:'กล่องจดหมาย'},{bind_title:'ตั้งรหัสผ่านการทำธุรกรรม',bind_name:'กล่องจดหมาย'}]
    },
    wdtg:{
      own_code:'รหัสเชิญพิเศษ',
      own_code_url:'การเชื่อมต่อคำเชิญพิเศษ',
      own_push_title:'การโปรโมตของฉัน',
      own_push_content:['รายได้คำเชิญทั้งหมด (การประเมินค่า)', 'จำนวนคำเชิญ', 'ผู้คน'],
      own_push_content_profit:['ผลประโยชน์การเชิญระดับ 1','ผลประโยชน์การเชิญระดับ 2','ผลประโยชน์การเชิญระดับ 3','ผลประโยชน์การเชิญระดับ 4'],
      own_push_content_num:['จำนวนคำเชิญที่ระดับแรก','จำนวนคำเชิญที่ระดับที่สอง','จำนวนคำเชิญที่ระดับที่สาม','จำนวนคำเชิญที่ระดับที่สี่'],
      own_push_profit_title: ['ID','profit','หมายเหตุข้อมูล','เพิ่มเวลา'],
      own_push_num_title: ['ID','name','phone','add time'],
    },
    jyzt_td: ['เวลา', 'รายละเอียด', 'จำนวน'],
    cbjl_td: ['เวลา', 'สกุลเงิน', 'ปริมาณ', 'สถานะ'],
    sfrz_txt: ['การตรวจสอบตัวตน', 'คุณได้ส่งการตรวจสอบแล้ว โปรดรอผล', 'คุณผ่านการตรวจสอบขั้นสูงแล้ว', 'ด้านหน้าของบัตรประจำตัว', 'ด้านหลังบัตรประจำตัว', 'การตรวจสอบสิทธิ์',' การตรวจสอบสิทธิ์ล้มเหลว โปรดยืนยันอีกครั้ง' ],

    zhsz_txt: ['ระดับความปลอดภัยของบัญชีของคุณ: #','ระดับความปลอดภัยของบัญชีของคุณ: # ปรับปรุงข้อมูลเพิ่มเติมและรับรองความปลอดภัยของบัญชี'],
    zhsz_m:'แข็งแกร่ง',
    zhsz_n:'อ่อนแอ',
    zhsz_p:'ไม่ปลอดภัย',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'ใส่รหัสผ่าน', value: 'บัญชีอินเทอร์เน็ตมีความเสี่ยงที่จะถูกขโมย ขอแนะนำให้คุณเปลี่ยนรหัสผ่านเป็นประจำเพื่อป้องกันความปลอดภัยของบัญชีของคุณ',value2:'', btn: 'แก้ไข',bind_email:'กรุณาผูกอีเมลหรือโทรศัพท์มือถือของคุณก่อน', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'รหัสผ่านการทำธุรกรรม', value: 'ตั้งรหัสผ่าน', btn: 'ไปที่ set', path: '/bindmpwd' }
    ],
    sksz_txt: ['การตั้งค่าใบเสร็จ', 'บันทึก'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'หน้าแรก',
    prev: 'หน้าก่อน',
    next: 'หน้าต่อไป',
    last: 'หน้าสุดท้าย',
    no_data: 'ไม่มีข้อมูล',
  },
  asset: {
    title: 'ทรัพย์สินของฉัน',
    zjhz: 'การโอนเงิน',
    cb: 'ฝากเงิน',
    gz: 'การประเมินมูลค่า USDT',
    atnv: [],
    zh_title: 'สินทรัพย์ทั้งหมดที่แปลงแล้ว: ',
    index_title: 'ทรัพย์สิน',
    address_title: 'สกุลเงิน',
    address_txt: ['กรุณาเลือก','ที่อยู่ถอน','โปรดป้อนเนื้อหา','หมายเหตุ','รายการที่อยู่'],
    address_btn: ['เพิ่ม', 'บันทึก', 'ลบ', 'แก้ไข'],
    address_td: ['สกุลเงิน', 'ที่อยู่ถอนเงิน', 'หมายเหตุ', 'การดำเนินการ'],
    currency_td: ['สกุลเงิน', 'พร้อมใช้งาน', 'แช่แข็ง', 'แปลงแล้ว'],

    table_title: 'สินทรัพย์รวม: ',
    table_address_title: 'การจัดการที่อยู่ถอน',
    table_td: ['สกุลเงิน', 'ใช้ได้', 'ตรึง', 'แปลง', 'การทำงาน'],
    table_btn: ['ฝากเหรียญ', 'ถอนเหรียญ' ,'บันทึก','โอน'],

    money_text: ['ที่อยู่ถอน', 'โปรดเลือก', 'จำนวน', 'ใช้ได้:', 'ค่าธรรมเนียมการจัดการ',
    'จำนวนที่มาถึง', 'รหัสผ่านการทำธุรกรรม', 'ป้ายกำกับ (บันทึก)', 'การถอนขั้นต่ำ'],
    money_btn: 'ถอนเงิน',
    xzbz: 'เลือกสกุลเงิน',
    money_msg: ['เตือนความจำที่อบอุ่น', '1. เวลาถอนคือ 12:00-24:00 น. ตามเวลาฮ่องกง โดยมีการถอน 2 ครั้งต่อวัน (ถอนขั้นต่ำ 100u ถอนสูงสุด 200,000u);', '2. ปัจจุบันการถอนเท่านั้น รองรับสกุลเงิน USDT และประเภทลิงค์กระเป๋าเงินคือ ERC20;','3. หลังจากส่งใบสมัครถอนเงินแล้ว เงินจะอยู่ในสถานะถูกระงับเนื่องจากการถอนเงินอยู่ในระหว่างดำเนินการ และเงินได้รับการจัดการชั่วคราวโดยระบบและไม่สามารถระงับได้ โดยคุณ อิสระในการควบคุม ไม่ได้หมายความว่าคุณสูญเสียทรัพย์สินหรือทรัพย์สินผิดปกติ โปรดรออย่างอดทนเพื่อรอการอนุมัติ','4. เวลาที่มาถึงหลังจากส่งคำขอถอนเงินจะขึ้นอยู่กับเวลายืนยันการบล็อก หากไม่คาดว่าจะถอนตัวหลังจากเวลาถอนตัว โปรดปรึกษาฝ่ายบริการลูกค้าเพื่อสอบถามข้อมูล',' 5. เพื่อป้องกันการตั้งค่าพฤติกรรมปัจจุบัน 90% ของจำนวนเงินที่ใช้ทั้งหมดจะต้องเริ่มต้นการถอน'],

    recharge_title: 'ที่อยู่เติมเงิน',
    recharge_btn: ['คัดลอก', 'รหัส QR', 'เติมเงิน'],
    recharge_text: ['ปริมาณ', 'การแจ้งเตือนอย่างอบอุ่น', 'อย่าเติมเงินสินทรัพย์ที่ไม่ใช่ USDT ไปยังที่อยู่ด้านบน มิฉะนั้น สินทรัพย์จะไม่ถูกเรียก ','เงินฝาก USDT รองรับเฉพาะวิธีการส่งแบบธรรมดา การฝากโดยใช้วิธีอื่น (ส่งทั้งหมด) ไม่สามารถโพสต์ได้ชั่วคราว โปรดเข้าใจ ','ข้อมูลรับรอง' ,'บรรยาย(ไม่จำเป็น)' ,'ชื่อเชน'],

    record_title: 'บันทึกทางการเงิน',
    record_td: ['ปริมาณ', 'บันทึก', 'เวลา'],

    transfer_title: 'โอน',
    transfer_btn: ['ทั้งหมด', 'โอน'],
    transfer_text: ['จาก', 'ถึง', 'โปรดป้อนจำนวนเงินที่โอน', 'มี:'],
    "bq": "ป้ายกำกับ (บันทึก)",
    "qsrbq": "กรุณาใส่ป้ายกำกับ",
    "yhktx": "ถอนบัตรธนาคาร",
    "yhmc": "ชื่อธนาคาร",
    "qsryhmc": "โปรดใส่ชื่อธนาคาร",
    "yhzh": "บัญชีธนาคาร",
    "qsryhzh": "โปรดใส่เลขบัญชีธนาคาร",
    "gjhkdm": "รหัสโอนเงินระหว่างประเทศ",
    "qsrgjhkdm": "โปรดใส่รหัสโอนเงินระหว่างประเทศ",
    "yhdz": "ที่อยู่ธนาคาร",
    "qsryhdz": "โปรดใส่ที่อยู่ธนาคาร",
    "skrxm": "ชื่อผู้รับเงิน",
    "qsrskrxm": "โปรดใส่ชื่อผู้รับเงิน",
    "skrdh": "โทรศัพท์ผู้รับเงิน",
    "qsrskrdh": "โปรดใส่หมายเลขโทรศัพท์ผู้รับเงิน",
    "skrdz": "ที่อยู่ผู้รับเงิน",
    "qsrskrdz": "โปรดใส่ที่อยู่ผู้รับเงิน"
  },
  text: {
    btn: 'กลับ',
    login: 'กรุณาเข้าสู่ระบบก่อน'
  },
  deal: {
    chooseType: 'ประเภทคอมมิชชั่น',
    choose: 'โปรดเลือก',
    balance: 'สมดุล:',
    account: ['บัญชี', 'ใช้ได้', '/หยุด' ,'โอน'],
    dir: ['ซื้อ', 'ขาย'],
    dir2: ['มีอยู่', 'พร้อมขาย'],
    cs: 'เลือกเอง',
    sxf: 'อัตราค่าธรรมเนียม',
    jye: 'จำนวนเงินธุรกรรม',
    sc_list: ['ตลาด', 'คู่เหรียญ', 'ราคาที่เพิ่มขึ้น'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['สกุลเงิน','ราคาล่าสุด','เพิ่มขึ้น'],
    k_line_txt: ['≈','', 'เพิ่ม', 'ราคาสูงสุด', 'ราคาต่ำสุด', 'ปริมาณ 24 ชั่วโมง'],
    tabListLTitle: ["คำสั่งปัจจุบัน", "คำสั่งประวัติศาสตร์"],
    tabListLEntrust: ["ซื้อใน", "ขาย"],
    tabListRTitle: ["การซื้อขายราคาจำกัด", "การซื้อขายราคาตลาด"],
    table_btn: ['ยกเลิกคำสั่งซื้อ'],
    index_td_l: ['เวลา' ,'วัตถุทางการค้า' ,'ปริมาณ', 'ราคา', 'การดำเนินการ'],
    index_td_r: ['ราคาล่าสุด', 'ทิศทาง', 'ราคา' ,'ปริมาณ'],
    index_td_r2: ['ธุรกรรมล่าสุด', 'เวลา', 'ราคา' ,'ปริมาณการซื้อขาย'],
    table_txt: ['สำเร็จ', 'ยกเลิกคำสั่งซื้อ'],

    db_1_txt: ['มีจำหน่าย', 'ราคาซื้อ', 'ราคาขาย', 'ปริมาณการซื้อ', 'ปริมาณการขาย', 'ปริมาณธุรกรรม', 'ซื้อในราคาที่ดีที่สุดในตลาด' ,'ขายในราคาที่ดีที่สุดในตลาด' ,'ซื้อมือ','ขายมือ'],
    db_2_txt: ['ราคา', 'เลเวอเรจ', 'โปรดเลือก', 'จำนวนล็อต', 'หนึ่งล็อตเท่ากับ', 'มือ' ,'มูลค่าตลาดตามสัญญา', 'มาร์จิ้น', 'ซื้อในราคาที่ดีที่สุดในตลาด', 'ในราคาที่ดีที่สุดในตลาด ขาย'],
    pathList: ['บันทึกสัญญา', 'บันทึกการทำธุรกรรม'],
    db_btn: ['ซื้อ (ไปยาว)', 'ขาย (สั้น)'],
    tabListLTitle2: ['คำสั่งซื้อปัจจุบัน'],

    lt_btn: ['ปิดตำแหน่งได้ด้วยคลิกเดียว','กำหนดกำไรและหยุดการขาดทุน','ปิดตำแหน่ง','ส่งทันที','คืน'],
    lt_txt: ['อัตราความเสี่ยง:','กำไรและขาดทุนของตำแหน่งทั้งหมด:'],
    lt_td: ['ประเภท', 'เลเวอเรจหลายตัว', 'ราคาตำแหน่ง', 'ราคาปัจจุบัน', 'มาร์จิ้น', 'ราคาทำกำไร', 'ราคาหยุดขาดทุน', 'เวลาเปิด', 'ล็อต', 'กำไรและขาดทุน', 'ปฏิบัติการ'],
    lt_dl: ['ตั้งราคาหยุดกำไรและหยุดขาดทุน', 'ขายทำกำไร', 'ราคาคัทลอส'],

    lt_0_btn: ['ยกเลิกคำสั่งซื้อ'],
    lt_0_td: ['ข้อมูลติดต่อ', 'สกุลเงิน', 'จำนวน', 'ราคาปัจจุบัน' ,'ค่าธรรมเนียมการจัดการ' ,'การดำเนินการ'],

    lt_1_btn: ['คัทลอส '],
    lt_1_txt: ['กำลังคัทลอส '],
    lt_1_td: ['ประเภท', 'ราคาตำแหน่ง', 'ราคาปัจจุบัน', 'มาร์จิ้น', 'ราคาทำกำไร', 'ราคาหยุดขาดทุน' ,'เวลาเปิด', 'ค่าธรรมเนียมการจัดการ' ,'กำไรและขาดทุน' ,'การดำเนินการ'],
    node_data: 'ไม่มีข้อมูล',

    lt_3_txt: ['ตำแหน่งปิด','ตำแหน่งปิด'],
    lt_3_td: ['ประเภท', 'ล็อต', 'ราคาตำแหน่ง', 'ราคาปิด' ,'ราคากำไร', 'ราคาหยุดขาดทุน', 'มาร์จิ้น' ,'มาร์จิ้นที่มีอยู่', 'เวลาเปิด', 'เวลาปิด', ' ค่าธรรมเนียมการจัดการ','กำไรขาดทุน', 'การดำเนินงาน'],

    lt_4_txt: ['ยกเลิกคำสั่งซื้อ'],
    cm: ['เวลาเปิดขาย', 'จำนวนเปิดขาย', '流通总量', '总凑价格', 'เว็บไซต์อย่างเป็นทางการ','กระดาษสีขาว','บทนำ'],
    qsrsl: 'โปรดใส่จำนวน',
    qsrss: 'กรุณาใส่ล็อต',
  },
  notice:{
      notice_title:'ศูนย์ประกาศ',
  },
  bzhl:{
    title: 'AI รับเหรียญ',
    title1: 'ปริมาณ AI',
    ttzbt: 'สร้างรายได้ทุกวัน',
    wdtg: 'โฮสติ้งของฉัน',
    zztgdzj: 'กองทุนภายใต้การดูแล',
    yjjrsy: 'ประมาณการทุกวัน',
    ljsy: 'รายได้สะสม',
    tgzdd: 'คำสั่งที่รอดำเนินการ',
    tgdd: 'คำสั่งเอสโครว์',
    t1: 'การจัดการทางการเงินที่มีความเสี่ยงต่ำและมีเสถียรภาพ สามารถแลกคืนได้ทุกเมื่อหากจำเป็น',
    t2: 'ผู้ช่วยจัดการเงินของคุณฟรี',
    cljxcp: 'อายุผลิตภัณฑ์',
    dbxe: 'จำกัดยอดเดียว',
    rsyl: 'อัตราผลตอบแทนรายวัน (%)',
    rsyl2: 'อัตราผลตอบแทนรายวัน：',
    zq: 'รายสัปดาห์',
    qmr: 'ไปซื้อ',
    ckgd: 'ดูเพิ่มเติม',
    cpgk: 'ภาพรวมผลิตภัณฑ์',
    pxsj: 'เวลาปันผล',
    tgzj: 'ทุนการดูแล',
    tqsh: 'ไถ่ถอนก่อนกำหนด',
    cpld: 'จุดเด่นของผลิตภัณฑ์',
    cpgz: 'กฎผลิตภัณฑ์',
    cont: 'การย้ายอิฐคือการโฮสต์ USDT บนแพลตฟอร์มและทีมงานมืออาชีพของแพลตฟอร์มดำเนินการสิทธิ์ในการย้ายอิฐ ผู้เข้าร่วมจะได้รับส่วนแบ่งรายได้จากการเคลื่อนย้ายอิฐของแพลตฟอร์มในช่วงระยะเวลาการดูแลกองทุน ซึ่งสามารถเข้าถึงได้ทุกเมื่อ ที่ปลอดภัยและสะดวก',
    zj: 'ทุน 100%',
    aqbz: 'ความปลอดภัย',
    jjrsy: 'รายได้วันหยุด',
    bjd: 'ไม่ขาดตอน',
    cgcrh: 'หลังฝากสำเร็จ',
    dtqx: 'วันหยุด',
    ljzr: 'โอนเลย',
    xqglgj: 'เครื่องมือจัดการเงินฟรี',
    ddh: 'เลขที่ใบสั่งซื้อ',
    tgje: 'ยอดเงินการดูแล',
    tgsj: 'รอบวัน',
    yhl: 'กำไร/วันคงเหลือ',
    xdsj: 'เวลาคำสั่งซื้อ',
    zt: 'สถานะ',
    fh: 'กลับ',
    qrnhsy: 'รายได้ต่อปีเจ็ดวัน',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: 'หยวน',
    tzfx: 'ความเสี่ยงในการลงทุน',
    shsc: 'เวลาแลกรับ',
    di: 'ต่ำ',
    yggzr: 'หนึ่งวันทำการ',
    msgsxf: 'ฟรีค่าสมัคร',
    mr: 'ทุกวัน',
    dqfh: 'ผลตอบแทนเมื่อครบกำหนด',
    ljgm: 'ซื้อทันที',
    tgz: 'ระหว่าการดูแล',
    sh: 'การไถ่ถอน',
    ywc: 'สำเร็จ',
    ysh: 'ถอนคืนแล้ว',
    all: 'ทั้งหมด',
    "xzbzts": "ง่ายและปลอดภัย สามารถเลือกเงินปันผลได้หลายสกุลเงิน",
    "qtbz": "เหรียญอื่นๆ"
  },
  pay:{
    qsrjymm: 'กรุณากรอกรหัสผ่านการทำธุรกรรม 6 หลัก',
    tbmmts: 'โปรดไปที่ศูนย์ผู้ใช้เพื่อตั้งรหัสผ่านการทำธุรกรรม',
  },
  tips:{
    qxztbdz: 'กรุณากรอกที่อยู่ถอนเงิน',
    qsrtbsl: 'โปรดใส่จำนวนการถอน'
  },
  statusText: ['ล้มเหลว','รอดำเนินการ', 'สำเร็จ'],
  dzrz: {
     title:'การตรวจสอบที่อยู่',
     sdddz:'ที่อยู่บิลค่าสาธารณูปโภค',
     zdtpsc:'อัปโหลดรูปภาพบิล',
     qsrsdddz:'คุณต้องกรอกข้อมูลที่อยู่และส่งบิลค่าสาธารณูปโภคหรือค่าที่อยู่บรอดแบนด์',
     qsczdtp:'โปรดอัปโหลดรูปภาพของใบเรียกเก็บเงิน',
     status: ['อยู่ระหว่างตรวจสอบ','ผ่านการตรวจสอบ'],
     qd:'ตกลง'
  },
  jgcc: {
    wtgd:'คำสั่งซื้อที่รอดำเนินการที่ได้รับมอบหมาย',
    cj:'ตกลง',
    jj:'แนะนำตัว',
    zc:'อยู่ในการระงับ',
    lszc:'ตำแหน่งทางประวัติศาสตร์',
    qblx:'ทุกประเภท',
    xj:'ราคาปัจจุบัน',
    sj:'เวลา',
    fx:'ทิศทาง',
    jg:'ราคา',
    sl: 'ปริมาณ',
    jgsj:'เวลาจัดส่ง',
    gmj:'ราคาซื้อ',
    jsj:'ราคาชำระ',
    yk:'กำไรขาดทุน',
    xq:'รายละเอียด',
    "mz": "งั้น",
    "md": "งุ่มง่าม",
    dqye:'ยอดดุลปัจจุบัน',
    gb:'ปิด',
    jxxd:'ดำเนินการสั่งซื้อต่อ',
    qrxd:'ยืนยันการสั่งซื้อ',
    ddqr:'ยืนยันการสั่งซื้อ',
    sxf:'ค่าธรรมเนียมการจัดการ',
    kyye:'สมดุล',
    jypz:'พันธุ์การค้า',
    jyfx:'ทิศทางการค้า',
    tzje:'จำนวนเงินลงทุน',
    tzjeTips:'จำนวนเงินลงทุนไม่สามารถเป็น 0',
    dqsj:'เวลาหมดอายุ',
    jssj:'เวลาชำระบัญชี',
    gmsj:'เวลาซื้อ',
    sy:'กำไร',
    zxje:'จำนวนขั้นต่ำ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje:'จำนวนสูงสุด ',
    qsrje:'กรุณาป้อนจำนวนเงิน',
    zxtzje:'จำนวนขั้นต่ำ',
    yebz:'ยอดเงินไม่เพียงพอ',
    xq:'รายละเอียด',
    ddz: 'รอ',
    jgjl:'บันทึกการจัดส่ง',
    bz:'สกุลเงิน',
    cz:'การทำงาน'
  },
  kjmb: {
    title:'เหรียญซื้อด่วน',
    fzcg:'คัดลอกสำเร็จ',
    ljmb:'ซื้อเหรียญทันที',
    lxkf:'ติดต่อฝ่ายบริการลูกค้า'
  },
  news: {
    title: 'ข้อความของฉัน',
    "gg": "ประกาศ",
    ckxq:'ดูรายละเอียด'
  },
  statusTabs:['คำสั่งซื้อที่รอดำเนินการ', 'กำลังดำเนินการ','คัทลอสแล้ว', 'ยกเลิกคำสั่งซื้อ'],
  "chongzhi":{
    "zy": "สำคัญ",
    "cbxx": "ข้อมูลการฝากโทเค็น",
    "qsrsl": "กรุณากรอกจำนวนเงินฝาก",
    "tips2": "1. ความเข้ากันได้กับกระเป๋าเงิน/แพลตฟอร์ม: นั่นคือ เครือข่ายได้รับการสนับสนุน หากแพลตฟอร์มเป้าหมายไม่สนับสนุนเครือข่ายการถอนเงินของคุณ สินทรัพย์จะไม่สามารถเรียกคืนได้",
    "tips3": "2. เครือข่ายเติมเงินและแพลตฟอร์มเป้าหมายเหมือนกัน หากคุณเลือกที่อยู่เป้าหมายคือเครือข่าย Ethereum แต่การเติมเงินเลือกสมาร์ทเชน TRC20 คุณอาจไม่สามารถเรียกข้อมูลสินทรัพย์ดิจิทัลของคุณได้",
    "tips4": "3. ตรวจสอบให้แน่ใจว่าที่อยู่และจำนวนเงินของคุณถูกต้องก่อนทำการชาร์จ",
    "tips5": "คำเตือน: เนื่องจากการไม่เปิดเผยตัวตนและความเป็นส่วนตัวของเครือข่ายที่ถูกบล็อก เมื่อคุณป้อนข้อมูลผิด คุณจะสูญเสียทรัพย์สินที่เกี่ยวข้อง โปรดตรวจสอบที่อยู่และปริมาณการเติมเงินของคุณอย่างระมัดระวัง",
    "tips2_1": "• โปรดอย่าเรียกเก็บเงินจากสินทรัพย์ที่ไม่ใช่สกุลเงินท้องถิ่นไปยังที่อยู่ด้านบน มิฉะนั้นจะไม่สามารถเรียกข้อมูลสินทรัพย์ได้",
    "tips2_2": "• ไม่สามารถส่งสกุลเงินดิจิทัลได้ทันเวลา เวลาที่มาถึงจริงขึ้นอยู่กับความเร็วในการยืนยันของบล็อคเชน",
    "tips2_3": "• ที่อยู่สำหรับเติมเงินของคุณจะไม่เปลี่ยนแปลงบ่อย คุณสามารถเติมเงินได้ หากมีการเปลี่ยนแปลง เราจะพยายามแจ้งให้คุณทราบผ่านทางประกาศบนเว็บไซต์หรืออีเมล",
  },
  "tibi":{
    "tbxx": "ข้อมูลการถอนเงิน",
    "qsrbq": "โปรดป้อนป้ายกำกับ",
    "tbTips1": "• เพื่อความปลอดภัยของเงิน เมื่อมีการเปลี่ยนแปลงนโยบายการรักษาความปลอดภัยของบัญชี เปลี่ยนรหัสผ่าน เราจะตรวจสอบการถอนเงินด้วยตนเอง โปรดอดทนรอเพื่อให้เจ้าหน้าที่ติดต่อคุณทางโทรศัพท์หรืออีเมล",
    "tbTips2": "• โปรดตรวจสอบให้แน่ใจว่าคอมพิวเตอร์และเบราว์เซอร์ของคุณปลอดภัยเพื่อป้องกันไม่ให้ข้อมูลถูกดัดแปลงหรือรั่วไหล",
    "tbTips3": "• สินทรัพย์ดิจิทัลที่คุณกล่าวถึงเป็นสินทรัพย์หลายสายแบบหนึ่งเหรียญ ไม่ว่าคุณจะเลือกเพิ่มจากสายใด หมายความว่าจำนวนสินทรัพย์ดิจิทัลทั้งหมดที่แสดงในหน้าถอนเงินที่คุณเป็นเจ้าของจะลดลง ตามจำนวนเงินที่เพิ่ม .",
  },
  "gjlb": "รายการประเทศ",
  "qxzgjlb": "กรุณาเลือกประเทศ / ภูมิภาค",
  "mbwt":{
    "title": "การตั้งค่าคำถามความปลอดภัยลับ",
    "mbwt": "คำถามเพื่อความปลอดภัย",
    "problem":[
      {
        "id": 1,
        "title": "ใครคือเพื่อนที่ดีที่สุดของคุณ?"
      },
      {
        "id": 2,
        "title": "ไอดอลของคุณคือใคร?"
      },
      {
        "id": 3,
        "title": "ที่ไหนที่คุณโหยหามากที่สุด?"
      }
    ],
    "qtxda": "โปรดใส่คำตอบ",
    "qsrxmm": "กรุณาใส่รหัสผ่านใหม่",
    "qqrmm": "โปรดยืนยันรหัสผ่าน",
    "sydqmmcz": "ใช้รหัสผ่านปัจจุบันในการรีเซ็ต",
    "zhmm": "ปัญหาด้านความปลอดภัย เรียกรหัสผ่าน",
    "ysz": "ตั้งค่าแล้ว",
    "tg": "ข้าม",
    "tj": "ส่ง",
    "zyts": "สำคัญ:",
    "zytsCont": "อย่าเปิดเผยคำตอบลับและรหัสยืนยัน และคำนึงถึงปัญหาด้านความปลอดภัยซึ่งจะช่วยให้คุณดึงรหัสผ่านของคุณ"
  },
  "zc":{
    "zclb": "รายการสินทรัพย์",
    "zczh": "การแปลงสินทรัพย์",
    "yczc": "ซ่อนยอดคงเหลือที่เป็น0"
  },
  "indexNew":{
    "t1": "ผู้นำระดับโลก",
    "t2": "แพลตฟอร์มบริการสินทรัพย์ดิจิทัล",
    "t3": "ทำธุรกรรมสินทรัพย์ดิจิทัลบล็อคเชนแบบครบวงจร",
    "t4": "หมายเลขโทรศัพท์มือถือ/อีเมล",
    "t5": "ลงทะเบียนเลย",
    "t6": "ยินดีต้อนรับลูกค้าจากทั่วทุกมุมโลกผ่าน MFTG",
    "t7":"ค้นพบและเริ่มต้นเส้นทางการเข้ารหัส"
  },
  "newReg":{
    "dl": ['อีเมล','มือถือ'],
    "cjzh": "สร้างบัญชี",
    "sysjhzyx": "ลงทะเบียนด้วยเบอร์มือถือ/อีเมล",
    "yhxy": "&lt;ข้อตกลงผู้ใช้&gt;",
    "yhxy2": "ฉันได้อ่านและยอมรับและ &lt;ข้อตกลงผู้ใช้&gt; ",
    "yxgz": "กรุณาใส่อีเมลที่ถูกต้อง",
    "dhgz": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง"
  },
  "indexNew2":{
    "t1": "ซื้อขายตามคำสั่งของเรา",
    "t2": "ใช้ Bitbank",
    "t3": "Bitbank คือการแลกเปลี่ยน bitcoin และสินทรัพย์เข้ารหัสที่ออกแบบมาอย่างชาญฉลาด มันง่ายมาก สะดวก ปลอดภัย และมีประสิทธิภาพ รองรับธุรกรรมบนเว็บและแพลตฟอร์มสมาร์ทโฟนที่หลากหลาย ข้อมูลธุรกรรมและแผนภูมิได้รับการอัปเดตแบบเรียลไทม์ ครอบคลุม การวิเคราะห์ราคาตลาดมีเครื่องมือวิเคราะห์ทางเทคนิคมากกว่า 60 รายการ เริ่มซื้อขาย",
    "ksjy": "เริ่มซื้อขาย",
    "ly": "5 เหตุผลที่ควรเลือก Bitbank",
    "item1_t1": "ปริมาณการซื้อขายชั้นนำ",
    "item1_t2": "อันดับ 1 * ปริมาณการซื้อขายสินทรัพย์ Crypto",
    "item1_t3": "การซื้อขายที่มีสภาพคล่องสูง สะดวกสบาย (ประสบการณ์การซื้อขายที่น่าพอใจ) แสดงรายการสินทรัพย์ดิจิทัล 12 ประเภท",
    "item2_t1": "การประเมินโดยบุคคลที่สามในระดับสูง",
    "item2_t2": "สภาพแวดล้อมการซื้อขายที่ปลอดภัย",
    "item2_t3": "ใช้ cold wallet ออฟไลน์ ใช้ Multisig เพื่อป้องกันไม่ให้แฮ็กเกอร์ ปกป้องทรัพย์สินของคุณด้วยเทคโนโลยีขั้นสูง",
    "item3_t1": "แอปพลิเคชั่นที่ใช้งานง่ายและเชื่อถือได้",
    "item3_t2": "ใช้งานง่ายและใช้งานง่าย",
    "item3_t3": "แอปพลิเคชันที่เชื่อถือได้พร้อมฟังก์ชันที่หลากหลาย สามารถรักษาโอกาสในการซื้อขายนอกธุรกรรมได้",
    "item4_t1": "เปิดทั้งวัน",
    "item4_t2": "ฝากทองได้",
    "item4_t3": "รองรับการฝากเงินตลอด 24 ชั่วโมง รวมถึงวันหยุดด้วย!",
    "item5_t1": "สมาร์ทโฟนและพีซี",
    "item5_t2": "การออกแบบที่มีมนุษยธรรม",
    "item5_t3": "แม้ว่าคุณจะใช้สมาร์ทโฟน คุณก็สามารถทำธุรกรรมที่ง่ายและผ่านการรับรองได้โดยไม่ลังเล",
    "aqkk": "ปลอดภัยและเชื่อถือได้",
    "aqkk2": "ธุรกรรม Bitbank Bitcoin",
    "cjzh": "สร้างบัญชี",
  },
  "xbsg":{
    "title": "ซนเหรียญใหม่",
    "wdsg": "รายละเอียด",
    "scts": "วันกักตัว: ",
    "sy": "ที่เหลืออยู่",
    "ljsg": "สมัครสมาชิกตอนนี้",
    "ysk": "ขายหมดแล้ว",
    "xzjdy": "สมัครสมาชิกตอนนี้",
    "dy": "ติดตาม",
    "fxjg": "ออกราคา",
    "fxl": "การไหลเวียน",
    "ssrq": "วันที่ลงรายการ",
    "yxqx": "ระยะเวลาที่ใช้ได้",
    "qsrsl": "กรุณาระบุจำนวนเงิน",
    "syl": "ที่เหลืออยู่",
    "sgrq": "ติดตาม",
    "sgsl": "จำนวน",
    "bz": "เหรียญ",
    "yebz": "ยอดเงิน USDT ไม่เพียงพอ",
    "tgsl": "ผ่านจำนวน",
    "shz": "ภายใต้การทบทวน",
    "wtg": "ไม่ผ่าน",
    "ytg": "ผ่านไป"
  },
  "wydb":{
    "title": "ยืม",
    "db": "ยืม",
    "dbz": "ยืม",
    "jl": "บันทึก",
    "jdzq": "ระยะเวลา (วัน)",
    "qhk": "เพื่อชำระคืน",
    "ljdb": "สะสม(usdt)",
    "dhkbs" :"ที่รอดำเนินการชำระเงิน",
    "jkje": "วงเงินกู้(usdt)",
    "qsrje": "กรุณาระบุจำนวนเงิน",
    "rll": "อัตราดอกเบี้ยรายวัน",
    "hkfs": "การชำระคืน",
    "dqych": "หมดอายุ",
    "lx": "ความสนใจ",
    "fkjg": "ผู้ให้กู้",
    "tpsc": "สินเชื่อเงินกู้ (อัพโหลดรูปภาพ)",
    "fwxx": "ข้อมูลที่อยู่อาศัย",
    "srzm": "หลักฐานแสดงรายได้ (ความสัมพันธ์ในการจ้างงาน)",
    "yhmx": "รายการเงินฝากถอนในบัญชีเงินฝาก",
    "zjz": "รูปถ่ายประจำตัว",
    "yd": "ฉันได้อ่านและตกลง",
    "xy": "สมัครสัญญาเงินกู้",
    "sqdb": "สมัครกลุ่มสินเชื่อ",
    "gb": "ปิด",
    "qd": "ตกลง",
    "ts": "โปรดตรวจสอบ สมัครสัญญาเงินกู้",
    "dbjl": "บันทึก",
    "hkhth": "รหัสการสั่งซื้อ",
    "wsh": "ยังไม่ได้ตรวจสอบ",
    "yfk": "เงินกู้",
    "sqrq": "เวลาสมัคร",
    "zq": "วงจร",
    "dbsl": "จำนวนซี่โครง",
    "zhke": "การชำระเงินทั้งหมด",
    "yhkxq": "รายละเอียดการชำระคืน",
    "bqyhk": "ชำระคืนในงวดปัจจุบัน(USDT)",
    "hktips": "กรุณาตรวจสอบให้แน่ใจว่ายอดเงินคงเหลือเพียงพอ หากยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วจึงค่อยชำระคืน",
    "bj": "อาจารย์ใหญ่",
    "jie": "ยืม",
    "ljhk": "ชำระคืนทันที",
    "qcz": "การฝาก",
    "yebzqxcz": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วค่อยชำระคืน",
    "znj": "ค่าธรรมเนียมการชำระล่าช้า",
    "yqts": "วันที่เกินกำหนด"
  },
  "hkxq":{
    "dd":"คำสั่ง",
    "fzhkdz":"คัดลอกที่อยู่การชำระเงิน",
    "hkxq": "รายละเอียดการชำระคืน",
    "zlx": "ดอกเบี้ยทั้งหมด",
    "zhk": "ชำระคืนทั้งหมด",
    "hkjg": "หน่วยงานการชำระคืน",
    "hkpz": "ใบรับรองการชำระหนี้"
  },
  "bbjyNew":{
    "jylx": "ชนิดของ",
    "jyze": "จำนวน"
  },
  "bind":{
    "title": "การตรวจสอบอีเมล",
    "ybd": "ผูกพัน",
    "wbd": "หลุด",
    "ts": "เพื่อปกป้องบัญชีของคุณ ขอแนะนำให้ผูกที่อยู่อีเมล",
    "qsryxdz": "โปรดใส่อีเมล"
  },
  "tipsNew": {
    "yjj": "ถูกปฏิเสธ",
    "shz": "การไถ่ถอน"
  },
  "newIndex2":{
    "zxhy": "ราคาล่าสุด",
    "jypt": "แพลตฟอร์มการซื้อขาย",
    "ssyc": "ย่อขนาดซ่อน",
    "hwzc": "ยังไม่ได้ลงทะเบียน?",
    "ljzc": "ลงทะเบียนตอนนี้และค้นพบโอกาสมากมาย!",
    "yyzh": "มีบัญชีอยู่แล้วใช่หรือไม่",
    "hjbj": "เข้าสู่ระบบถ้าคุณมีบัญชี ไม่ได้เจอกันนาน!",
    "lmdh": "การนำทางคอลัมน์",
    "ghdjy": "ข้อตกลงที่ดีกว่า ชีวิตที่ดีขึ้น",
    "ghdjy02": "ศูนย์กลางการซื้อขาย crypto ที่ล้ำสมัยที่สุดในโลกอยู่ที่นี่แล้ว ที่ซึ่งคุณสามารถซื้อ แลกเปลี่ยน และรับ cryptocurrencies ด้วย cryptocurrencies หลายร้อยรายการเพียงปลายนิ้วสัมผัส",
    "indexCont01": "อยู่ข้างคุณเสมอ",
    "indexCont02": "ซื้อขายในตลาดสปอตและมาร์จิ้นของเราด้วยตัวเลือกเงินทุนขั้นสูง การดำเนินการที่รวดเร็วและสภาพคล่องที่ลึก",
    "indexCont03": "API ที่ทรงพลัง",
    "indexCont04": "จัดการตำแหน่งของคุณได้อย่างง่ายดายด้วย API ที่ใช้งานง่าย แพลตฟอร์มการซื้อขายและตัวเลือกคำสั่งขั้นสูง",
    "indexCont05": "สินทรัพย์ดิจิทัลคุณภาพสูง",
    "indexCont06": "9 ปี 0 อุบัติเหตุ",
    "indexCont07": "การควบคุมความเสี่ยงด้านความปลอดภัยสูงสุด",
    "indexCont08": "เลเวอเรจสูงสุด 25 เท่า",
    "indexCont09": "ซื้อขาย Bitcoin CFD ด้วยเลเวอเรจสูงสุด 25x",
    "indexCont010": "สำรองความปลอดภัย",
    "indexCont011": "สภาพคล่องลึก",
    "indexCont012": "เทคโนโลยีหนังสือสั่งซื้อหลายตลาดที่เป็นเอกสิทธิ์ขั้นสูงของเราช่วยเพิ่มสภาพคล่อง เพิ่มสเปรด และลดการคลาดเคลื่อน",
    "indexCont013": "ค่ากำหนดของผู้ใช้",
    "indexCont014": "ครอบคลุมประเทศ",
    "indexCont015": "จุดแข็งของเรา",
    "indexCont016": "ซื้อขายในตลาดสปอตและมาร์จิ้นของเราด้วยตัวเลือกเงินทุนขั้นสูง การดำเนินการที่รวดเร็วและสภาพคล่องที่ลึก",
    "indexCont017": "ที่เก็บข้อมูลที่ปลอดภัย",
    "indexCont018": "เราใช้ Cold Wallet และเทคโนโลยีการคำนวณแบบหลายฝ่าย (MPC) เพื่อจัดการสินทรัพย์ดิจิทัล",
    "indexCont019": "ปลอดภัยไว้ก่อน",
    "indexCont020": "เราใช้เทคโนโลยีล่าสุดเพื่อให้เงินของคุณปลอดภัย นำหน้าบั๊กและพยายามหาประโยชน์",
    "indexCont021": "ถอนด่วน",
    "indexCont022": "ด้วยการใช้การคำนวณแบบหลายฝ่าย เราสามารถให้บริการถอนเงินได้อย่างรวดเร็วตลอด 24/7 ในขณะที่ยังคงมาตรฐานความปลอดภัยที่เข้มงวดของเรา",
    "indexCont023": "ซื้อ ขาย Cryptocurrency",
    "indexCont024": "เข้าร่วมแพลตฟอร์มการซื้อขายที่ปลอดภัยที่สุดในโลก",
    "indexCont025": "ซื้อและขาย Bitcoin, Ethereum, XRP และ cryptocurrencies อื่น ๆ อีกมากมายโดยใช้คำสั่งหรือ cryptocurrencies",
    "yqwj": "10 ล้าน+",
    "dlzc": "เข้าสู่ระบบเพื่อลงทะเบียน",
    "yzm": "รหัสยืนยัน",
    "qrmm": "ยืนยันรหัสผ่าน"
  },
  "langNew2":{
    "flzq": "ศูนย์กลางของรางวัล",
    "qdjl": "รางวัลเข้าสู่ระบบ",
    "mrqdjl": "รางวัลลงชื่อเข้าใช้รายวัน",
    "qd": "เข้าสู่ระบบ",
    "yqd": "ลงทะเบียนเข้า",
    "hdgz": "กฎของกิจกรรม",
    "qdjl2": "บันทึกการเช็คอิน",
    "qdcg": "ลงชื่อเข้าใช้สำเร็จ",
    "yhd": "ได้มา",
    "lq": "รับ",
    "dyt": "วันที่ 1",
    "det": "วันที่ 2",
    "dst": "วันที่ 3",
    "dsit": "วันที่ 4",
    "dwt": "วันที่ 5",
    "dlt": "วันที่ 6",
    "dqt": "วันที่ 7",
    "jxz": "กำลังดำเนินการ",
    "cjxnzh": "สร้างบัญชีสาธิต",
    "sy":"หน้าแรก",
    "sc":"ตลาด",
    "sclb":"รายการตลาด",
    "jy":"ซื้อขาย",
    "zh":"บัญชี",
    "db":"เงินกู้",
    "zchm":"ทะเบียนเลขที่",
    "cp":"ผลิตภัณฑ์",
    "tzjd":"สินเชื่อเพื่อการลงทุน",
    "zxzc":"การสนับสนุนทางออนไลน์",
    "xd":"คำสั่ง",
    "zzjptgmnr":"ลงทุนในอนาคตของคุณ ขยายพอร์ตโฟลิโอของคุณในระบบการเงินที่ยุติธรรมและเปิดกว้าง",
    "yy":"แอป",
    "pqnr":"ธนาคารบนมือถือที่ฉีกกฎเกณฑ์เดิมๆ และมอบเครื่องมือการจัดการทางการเงินที่แม่นยำแก่คุณ",
    "jiami":"การเข้ารหัสลับ",
    "tgnr":"ด้วยการฝากเงินโดยใช้สกุลเงินดิจิทัล คุณจะได้รับความปลอดภัยอีกชั้นหนึ่งและรับประกันการประมวลผลธุรกรรมที่รวดเร็ว",
    "jyl":"ปริมาณการซื้อขาย 24 ชม",
    "ssjmhb":"รายการ Crypto",
    "zchy":"ผู้ใช้ที่ลงทะเบียน",
    "djxz":"คลิกเพื่อดาวน์โหลด",
    "azsc":"แอนดรอยด์มาร์เก็ต",
    "pgsd":"แอปเปิ้ลสโตร์",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "สกุลเงินดิจิทัล",
  //   "gjs": "โลหะ",
  //   "yy": "น้ำมันดิบ",
  //   "jy": "ซื้อขาย",
  //   "jmhb": "สกุลเงินดิจิทัล",
  //   "yxhy": "สัญญาถาวร",
  //   "gdjy": "คำสั่งซื้อที่รอดำเนินการ",
  //   "khh": "ธนาคารบัญชี",
  //   "qsrkhh": "กรุณากรอกธนาคาร",
  //   "yhkh": "บัญชีธนาคาร",
  //   "qsryhkh": "กรุณาใส่เลขบัญชีธนาคาร",
  //  },
   "login":{
     login: 'กรุณาเข้าสู่ระบบ',
     msg: 'กรุณาใส่บัญชีที่ลงทะเบียนของคุณ',
     list: ['มือถือ/อีเมล', 'รหัสผ่าน', 'ลืมรหัสผ่านใช่หรือไม่', 'เข้าสู่ระบบ', 'ไม่มีบัญชี ลงทะเบียนเลย'],
     message: 'ต้องระบุบัญชีหรือรหัสผ่าน',
     "cdlks":"เริ่มต้นด้วยการเข้าสู่ระบบ!",
     "zh":"บัญชี",
     "qsrzh":"กรอกชื่อผู้ใช้ของคุณ",
     "mm":"รหัสผ่าน",
     "qsrmm":"ใส่รหัสผ่าน",
     "dl":"เข้าสู่ระบบ",
     "wjmm":"ลืมรหัสผ่าน",
     "qbdl":"เข้าสู่ระบบด้วยกระเป๋าเงิน",
     "myzh":"ฉันไม่มีบัญชี?",
     "zc":"ลงชื่อ",
     "yzm":"รหัสยืนยัน",
     "qsryzm":"ระบุรหัสยืนยืน",
     "hqyzm":"ส่งรหัส",
     "qrmm":"ยืนยันรหัสผ่าน",
     "qsrqrmm":"ยืนยันรหัสผ่าน",
     "lcmmbyz":"การป้อนรหัสผ่านทั้งสองไม่สอดคล้องกัน",
     "mmts":"รหัสผ่านมีความยาว 6-12 ตัวอักษร",
     "sjtx":"ข้อผิดพลาดรูปแบบหมายเลขโทรศัพท์",
     "yxts":"ข้อผิดพลาดรูปแบบอีเมล",
     "qr":"ตกลง",
     "sjzc":"มือถือ",
     "sjh":"หมายเลขโทรศัพท์",
     "qsrsjh":"ป้อนหมายเลขโทรศัพท์",
     "yqm":"รหัสคำเชิญ (ไม่บังคับ)",
     "qsryqm":"กรอกรหัสเชิญ",
     "yxzc":"อีเมล",
     "wyydbzx":"เห็นด้วย",
     "yhxy":"<ข้อตกลงการบริการผู้ใช้>",
     "yhxy2":"ข้อตกลงการบริการผู้ใช้",
     "ysyx":"<ข้อตกลงคุ้มครองความเป็นส่วนตัว>",
     "yx":"อีเมล",
     "qsryx":"กรอกอีเมล",
     "yxgsbzc":"อีเมลไม่ถูกต้อง",
     "cjmnzhcg":"สร้างบัญชีทดลองสำเร็จแล้ว",
     "tcmnzh":"ออกจากบัญชีทดลอง",
     "qbdlts":"กรุณาใช้การลงชื่อเข้าใช้กระเป๋าเงิน DAPP",
   },
  //  "index":{
  //    "xgnysx":"คุณสมบัติใหม่ออนไลน์แล้ว!",
  //    "hyld":"ยินดีต้อนรับสู่แพลตฟอร์มการซื้อขายทางการเงินที่ได้รับรางวัลของเรา และสำรวจโลกการเงินในอนาคตกับนักลงทุนทั่วโลก",
  //    "symncz":"ใช้บัญชีทดลอง",
  //    "zdjyfy":"ค่าธรรมเนียมการทำธุรกรรมขั้นต่ำ <0.3%",
  //    "jysyzc":"ซื้อขายทรัพย์สินทั้งหมดของคุณในที่เดียว",
  //    "hbsp":"ฟอเร็กซ์, สกุลเงินดิจิทัล, หุ้น, ดัชนี, สินค้าโภคภัณฑ์",
  //    "ksjy":"เริ่ม",
  //    "jdewd":"เรียบง่ายและมั่นคง",
  //    "aizb":"การซื้อขาย AI ทองคำ",
  //    "srjh":"สร้างแผนรายได้ของคุณในคลิกเดียว",
  //    "kssy":"เริ่มใช้",
  //    "dlyhggdje":"อัตราดอกเบี้ยต่ำและจำนวนเงินที่สูงขึ้น",
  //    "jmhbdk":"สินเชื่อ Cryptocurrency",
  //    "zmyrhdyp":"ยืมจุด cryptocurrency โดยไม่มีหลักประกันใด ๆ",
  //    "gs":"บริษัท",
  //    "gywm":"เกี่ยวกับเรา",
  //    "xkzjd":"การกำกับดูแลใบอนุญาต",
  //    "bzzx":"ศูนย์ช่วยเหลือ",
  //    "zhengce":"นโยบาย",
  //    "tkytj":"ข้อกำหนดและเงื่อนไข",
  //    "yszc":"นโยบายความเป็นส่วนตัว",
  //    "sm":"คำแถลง",
  //    "flxx":"ข้อมูลทางกฎหมาย",
  //    "mzsm":"ข้อสงวนสิทธิ์",
  //    "fxjg":"คำเตือนความเสี่ยง",
  //    "gygg":"เกี่ยวกับการโฆษณา",
  //    "gg":"ประกาศ",
  //  },
   "hq":{
     "wh":"ฟอเร็กซ์",
     "szhb":"การเข้ารหัสลับ",
     "gp":"คลังสินค้า",
     "zs":"ดัชนี",
     "eft":"อีทีเอฟ",
     "mc":"ชื่อ",
     "xs":"24ชม.%",
     "tb":"แผนภูมิ",
     "jg":"ราคา",
   },
   "user":{
     "wdzh":"บัญชีของฉัน",
     "zh":"บัญชี: ",
     "dk":"เงินกู้: ",
     "sydbzj":"มาร์จิ้นที่ใช้: ",
     "yqll":"กำไรที่คาดหวัง: ",
     "qtgn":"ฟังก์ชั่นอื่นๆ",
     "cz":"เงินฝาก",
     "tx":"ถอน",
     "dh":"แลกเปลี่ยน",
     "zhyz":"การรับรอง KYC",
     "zhjl":"บันทึกบัญชี",
     "yqhy":"ชวนเพื่อน",
     "flzq":"โซนสวัสดิการ",
     "ggmm":"เปลี่ยนรหัสผ่าน",
     "sz":"การตั้งค่า",
     "cjwtjd":"คำถามที่พบบ่อย",
     "fzdz":"คัดลอกที่อยู่",
     "sl":"ปริมาณ...",
     "qsrsl":"ป้อนปริมาณ",
     "dd":"รับ (USDT): ",
     "sczm":"อัพโหลดบัตรกำนัล",
     "qsczm":"กรุณาอัพโหลดบัตรกำนัล",
     "tj":"ส่ง",
     "czjl":"บันทึกการฝากเงิน",
     "ddh":"เลขที่",
     "wsh":"ไม่ได้รับการตรวจทาน",
     "ywc":"สมบูรณ์",
     "bz":"ชื่อ: ",
     "sl2":"ปริมาณ: ",
     "sj":"เวลา: ",
     "srsl":"ใส่จำนวน...",
     "dd2":"รับ: ",
     "qskgzflhd":"โปรดใส่ใจกับกิจกรรมด้านสวัสดิการอยู่เสมอเราจะปล่อยกิจกรรมเหล่านั้นเป็นครั้งคราว",
     "hdlb":"รายการกิจกรรม",
     "ckxq":"ดูรายละเอียด",
     "wdjl":"รางวัลของฉัน",
     "yiji":"ระดับ 1",
     "erji":"ระดับ 2",
     "sanji":"ระดับ 3",
     "je":"จำนวน",
     "sj2":"เวลา",
     "yyxz":"ภาษา",
     "tcdl":"ออกจากระบบ",
     "je2":"จำนวนเงิน (USD)...",
     "qsrje":"ป้อนจำนวนเงิน",
     "jsdz":"ที่อยู่ที่ได้รับ...",
     "qsrjsdz":"กรอกที่อยู่รับ",
     "sjdz":"มาถึงจริง: ",
     "sxf":"ค่าธรรมเนียม: ",
     "txsm1":"การถอนเงินต้องเสียค่าธรรมเนียม 5% ซึ่งต้องได้รับการยืนยันจากโหนดเครือข่ายก่อนจึงจะเครดิตได้",
     "txsm2":"กรุณาอย่าโอน cryptocurrencies ไปยังคนแปลกหน้า",
     "tz":"แจ้ง",
     "wdyq":"คำเชิญของฉัน",
     "yhid":"UID",
     "hdjl":"รับรางวัล USD",
     "yqsm":"เชิญเพื่อนของคุณให้เข้าร่วมการวัดปริมาณ Ai เช่าเครื่องขุด และแลกเปลี่ยนผลิตภัณฑ์เพื่อรับรางวัลสกุลเงินดิจิทัล",
     "yqsy":"รายได้จากคำเชิญ",
     "yqrs":"จำนวนคนที่ได้รับเชิญ",
     "tgljyq":"เชิญตามลิงค์ครับ",
     "lj":"ลิงค์",
     "yqm":"รหัสการเชิญ",
     "cbtb":"ฝาก&ถอน",
     "jymx":"รายละเอียดการทำธุรกรรม",
     "yqhyjl":"รางวัลสำหรับการชวนเพื่อน",
     "aidd":"คำสั่งการซื้อขาย Golden AI",
     "jdls":"ประวัติการกู้ยืม",
     "etfdd":"คำสั่งอีทีเอฟ",
     "jmhbdd":"คำสั่ง Cryptocurrency",
     "whdd":"คำสั่งฟอเร็กซ์",
     "gpdd":"คำสั่งซื้อหุ้น",
     "qx":"ยกเลิก",
     "zc":"สินทรัพย์",
     "zzc":"สินทรัพย์รวม",
     "ky":"มีอยู่",
     "zh2":"แปลงแล้ว (USDT)",
     "xzbz":"เลือก: ",
     "sztkts":"สำคัญ: โปรดไปที่ศูนย์ความปลอดภัยเพื่อตั้งรหัสผ่านการทำธุรกรรม",
     "jymm":"รหัสผ่านการทำธุรกรรม",
     "szjymm":"ตั้งรหัสผ่านการทำธุรกรรม",
     "qsrjymm":"รหัสผ่านการทำธุรกรรม",
     "zdsl":"จำนวนขั้นต่ำ",
     "bq":"แท็ก(บันทึก)",
     "qsrbq":"ใส่แท็ก",
     "yhktx":"โอนเงินผ่านธนาคาร",
     "yhmc":"ชื่อธนาคาร",
     "qsryhmc":"ป้อนชื่อธนาคาร",
     "yhzh":"บัญชีธนาคาร",
     "qsryhzh":"กรอกหมายเลขบัญชีธนาคาร",
     "gjhkdm":"รหัสสวิฟท์",
     "qsrgjhkdm":"กรอกรหัส SWIFT",
     "yhdz":"ที่อยู่ธนาคาร",
     "qsryhdz":"ป้อนที่อยู่ธนาคาร",
     "skrxm":"ชื่อผู้รับเงิน",
     "qsrskrxm":"ป้อนชื่อผู้รับเงิน",
     "skrdh":"หมายเลขโทรศัพท์ผู้รับเงิน",
     "qsrskrdh":"ป้อนหมายเลขโทรศัพท์ของผู้รับเงิน",
     "skrdz":"ที่อยู่ผู้รับเงิน",
     "qsrskrdz":"ป้อนที่อยู่ผู้รับเงิน",
     "tbjl":"บันทึกการถอนเงิน",
     "fzcg":"คัดลอกเรียบร้อยแล้ว",
     "aqzx":"ศูนย์รักษาความปลอดภัย",
     "yxrz":"การรับรองความถูกต้องของอีเมล",
     "ybd":"ผูกพัน",
     "wbd":"ไม่ผูกมัด",
     "yrz":"ตรวจสอบแล้ว",
     "wrz":"ไม่ได้รับการรับรอง",
     "ts":"เพื่อปกป้องบัญชีของคุณ ขอแนะนำให้ผูกที่อยู่อีเมลของคุณ",
     "qsryxdz":"กรอกอีเมล",
     "dlmm":"รหัสผ่านการเข้าใช้งาน",
     "mbwtsz":"การตั้งค่าปัญหาด้านความปลอดภัย",
     "mbwt":"ปัญหาด้านความปลอดภัย",
     "qtxda":"กรุณากรอกคำตอบ",
     "zyts":"สำคัญ: ",
     "zytsCont":"โปรดอย่าเปิดเผยคำตอบเพื่อความปลอดภัยและรหัสยืนยัน และจำคำถามเพื่อความปลอดภัยซึ่งจะช่วยให้คุณกู้คืนรหัสผ่านของคุณได้",
     "qsrxmm":"ป้อนรหัสผ่านใหม่",
     "sydqmmcz":"รีเซ็ตด้วยรหัสผ่านปัจจุบัน",
     "zhmm":"ปัญหาด้านความปลอดภัยในการดึงรหัสผ่าน",
     "ysz":"ได้รับการตั้งค่า",
     "tg":"ไม่สนใจ",
     "qsrdlmm":"ใส่รหัสผ่านของคุณ",
     "bzxz":"เลือก: ",
     "zwsj":"ไม่มีข้อมูล",
     "qd":"ตกลง",
     "zsgd":"แสดงมากขึ้น",
     "zdss":"ขนาดล็อตขั้นต่ำ",
     "mnjy":"บัญชีทดลอง",
     "sx":"การคัดกรอง",
   },
   "zb":{
     "tgdd":"AI จัดการคำสั่งซื้อ",
     "tgz":"อยู่ในความควบคุมตัว",
     "ysh":"แลกแล้ว",
     "shz":"กำลังแลก",
     "zq":"วงจร: ",
     "tian":"วัน",
     "syl2":"อัตราผลตอบแทน: ",
     "rgjg":"ราคาสมัครสมาชิก: ",
     "rgjg2":"ราคาสมัครสมาชิก",
     "xdsj":"เวลาสั่งซื้อ: ",
     "yhl":"กำไร: ",
     "syts":"จำนวนวันที่เหลือ: ",
     "sh":"การไถ่ถอน",
     "syl":"อัตราผลตอบแทน",
     "bz":"ชื่อ",
     "dl":"อัตราแลกเปลี่ยน",
     "tgts":"วันที่จัดงาน: ",
     "tgsl":"ปริมาณโฮสติ้ง",
     "qsrtgsl":"ป้อนจำนวนโฮสติ้ง",
     "dbxe":"ขีด จำกัด การทำธุรกรรมเดียว",
     "ljtg":"เป็นเจ้าภาพตอนนี้",
     "zztg":"กองทุนที่อยู่ในความดูแล",
     "yjjrsy":"รายได้โดยประมาณวันนี้",
     "ljsy":"รายได้สะสม",
     "tgzdd":"สั่งฝาก.",
     "ljzc":"โอนเลย.",
     "gz":"กฎ",
     "cpzq":"วงจรผลิตภัณฑ์",
     "gm":"ซื้อ",
     "ts":"สำคัญ",
     "shts":"คุณกำลังอยู่ในขั้นตอนการดำเนินการไถ่ถอน และคุณจะสูญเสีย 5% หากคุณแลกก่อนครบกำหนด คุณแน่ใจหรือว่าจะแลก?",
     "xgcs":"จำกัดจำนวนการซื้อ",
   },
   "dk":{
     "dk":"เงินกู้",
     "dkzh":"บัญชีเงินกู้",
     "yzsf":"ยืนยันตัวตนของคุณและรับจำนวนเงินกู้เพิ่มขึ้น!",
     "ksyz":"เริ่มการยืนยัน",
     "wxj":"อยากยืม...",
     "dkqx":"ระยะเวลากู้ยืม (วัน): ",
     "mrll":"อัตราดอกเบี้ยรายวัน: ",
     "lxze":"ดอกเบี้ยรวม: ",
     "dkts":"ไม่ต้องใช้ดอกเบี้ยสำหรับเงินกู้เป็นเวลา 3 วันและสามารถจ่ายดอกเบี้ยได้หลังจากนั้น",
     "xzj":"กู้ได้เลย",
     "wyydbzx":"เห็นด้วย",
     "dkfwxy":"<สัญญาบริการสินเชื่อ>",
     "dkfwxy2":"สัญญาการให้บริการสินเชื่อ",
     "dkysxy":"ข้อตกลงความเป็นส่วนตัวของสินเชื่อ",
     "dkjl":"ประวัติการกู้ยืม",
     "hth":"เลขที่",
     "yfk":"เบิกจ่ายแล้ว",
     "lx":"ความสนใจ: ",
     "zhke":"จำนวนการชำระคืนทั้งหมด: ",
     "znj":"ค่าธรรมเนียมการชำระล่าช้า: ",
     "znjl":"อัตราค่าธรรมเนียมล่าช้า: ",
     "yqts":"วันที่เกินกำหนด: ",
     "qhk":"เพื่อชำระคืน",
     "tpsc":"สินเชื่อสินเชื่อ (อัพโหลดภาพ)",
     "fwxx":"ข้อมูลที่อยู่อาศัย",
     "srzm":"หลักฐานแสดงรายได้ (ความสัมพันธ์ในการจ้างงาน)",
     "yhmx":"รายละเอียดธนาคาร",
     "zjz":"รูปถ่ายประจำตัว",
     "ljdk":"กู้ได้เลย",
     "xm":"ชื่อ",
     "ndxm":"ชื่อของคุณ",
     "qsrndxm":"ใส่ชื่อของคุณ",
     "gj":"ประเทศ",
     "ndgj":"ประเทศของคุณ",
     "qsrndgj":"ป้อนประเทศของคุณ",
     "dz":"ที่อยู่",
     "nddz":"ที่อยู่ของคุณ",
     "qsrnddz":"ป้อนที่อยู่ของคุณ",
     "csrq":"วันเกิด",
     "ndcsrq":"วันเกิดของคุณ",
     "qsrndcsrq":"กรอกวันเกิดของคุณ",
     "dhhm":"หมายเลขโทรศัพท์",
     "nddhhm":"หมายเลขโทรศัพท์ของคุณ",
     "qsrnddhhm":"ป้อนหมายเลขโทรศัพท์ของคุณ",
     "zj":"เอกสาร",
     "sfzm":"เอกลักษณ์เชิงบวก",
     "qscsfzm":"อัปโหลดด้านบวกของตัวตนของคุณ",
     "sffm":"ตรงข้ามกับตัวตน",
     "qscsffm":"อัปโหลดด้านหลังของตัวตนของคุณ",
     "ddqr":"ยืนยันการสั่งซื้อ",
     "jk":"เงินกู้: ",
     "dkqx2":"ระยะเวลาเงินกู้: ",
     "qrxd":"ยืนยันรายการ",
     "yhkxq":"รายละเอียดการชำระหนี้ที่ครบกำหนดชำระ",
     "hkqr":"การยืนยันการชำระคืน",
     "yhk":"กำหนดชำระคืน: ",
     "jksj":"ระยะเวลาการยืม: ",
     "ljhk":"จ่ายเงินออกทันที",
   },
   "jy":{
     "rq":"วันที่",
     "qqjy":"บันทึกตัวเลือก",
     "hyjy":"สัญญา",
     "qqhy":"ตัวเลือก",
     "dqwt":"รอดำเนินการ",
     'wtz':"ในการมอบหมาย",
     "hyjl":"บันทึกสัญญา",
     "shou":"มากมาย",
     "dk":"โอ้: ",
     "zhjg":"ล่าสุด: ",
     "jyfy":"ค่าธรรมเนียมการทำธุรกรรม: ",
     "kfsj":"เวลาทำการ: ",
     "gg":"คันโยก: ",
     "pl":"ชุด: ",
     "kpj":"ราคาเปิด: ",
     "yk":"กำไรและขาดทุน: ",
     "cd":"ยกเลิกคำสั่งซื้อ",
     "jsj":"ราคาชำระบัญชี: ",
     "fx":"ทิศทาง: ",
     "jgsj":"เวลาจัดส่ง: ",
     "gb":"ปิด",
     "jxxd":"ดำเนินการต่อ",
     "xj":"ขีดจำกัด: ",
     "gm":"ซื้อ: ",
     "sl":"ปริมาณ",
     "fy":"ค่าใช้จ่าย: ",
     "tzbzj":"ปรับระยะขอบ",
     "zyzs":"ขายทำกำไรและหยุดการขาดทุน",
     "pc":"ปิดตำแหน่ง",
     "mr":"ซื้อ",
     "zjbzj":"เพิ่มอัตรากำไรขั้นต้น",
     "jsbzj":"ลดระยะขอบ",
     "yxhy":"การซื้อขายตามสัญญา: ",
     "cc":"ตำแหน่ง: ",
     "cc2":"ตำแหน่ง",
     "cwbzk":"อัตรากำไรขั้นต้นของตำแหน่ง: ",
     "zdzjbzj":"เพิ่มมาร์จิ้นสูงสุด: ",
     "zjbzj2":"เพิ่มมาร์จิ้น: ",
     "qsrzbzj":"กรุณากรอกการฝากเงิน",
     "yxhy2":"ตลอดไป",
     "kp":"แบนก็ได้",
     "zhang":"เปิด",
     "xj2":"ขีดจำกัด",
     "zy":"ขายทำกำไร",
     "zs":"หยุดการสูญเสีย",
     "ssjyzl":"ค้นหาประเภทธุรกรรม",
     "ddb":"สั่งหนังสือ",
     "di":"ล: ",
     "gao":"ชม: ",
     "gb2":"ค: ",
     "fz":"นาที",
     "mai":"ซื้อ: ",
     "zhang2":"ลุกขึ้น",
     "tie":"ตก",
     "sy":"กลับ",
     "kz":"รั้น",
     "kt":"งุ่มง่าม",
     "bndy":"ไม่สามารถต่ำกว่า",
     "sxbzj":"เงินประกันที่จำเป็น: ",
     "ky":"มีอยู่: ",
     "sj":"ตลาด",
     "mc":"ขาย",
     "zxtzsl":"ปริมาณขั้นต่ำ",
     "min":"จำนวนขั้นต่ำ",
     "max":"ปริมาณมากที่สุด",
     "yebz":"ยอดคงเหลือไม่เพียงพอ",
     "ddz":"ซึ่งรอคอย",
     "wtzl":"จำนวนคอมมิชชั่น: ",
     "wtjg":"ราคาคอมมิชชั่น: ",
     "ycd":"ยกเลิก",
     "lswt":"ประวัติศาสตร์",
     "qsrzyjg":"กรุณากรอกราคาขายทำกำไร",
     "qsrzsjg":"กรุณากรอกราคาหยุดขาดทุน",
     "ccsl":"จำนวนตำแหน่ง: ",
     "ccjg":"ราคาตำแหน่ง: ",
     "ggbs":"ใช้ประโยชน์จากหลายรายการ: ",
     "zy2":"ขายทำกำไร: ",
     "zs2":"หยุดการสูญเสีย: ",
     "zje":"เงินก้อน: ",
     "ss":"จำนวนมาก: ",
     "kcjg":"ราคาเปิด: ",
     "bzjl":"อัตรามาร์จิ้น: ",
     "lscc":"ตำแหน่งประวัติ",
     "gmj":"ราคาซื้อ: ",
     "guadan":"คำสั่งซื้อที่รอดำเนินการ",
     "dqjg":"ราคาปัจจุบัน: ",
     "gdjg":"ราคาคำสั่งซื้อที่รอดำเนินการ: ",
     "pcjg":"ราคาปิด: ",
     "ccsj":"ระยะเวลาดำรงตำแหน่ง: ",
     "gdsj":"คำสั่งซื้อที่รอดำเนินการ: ",
     "pcsj":"เวลาปิด: ",
     "fdjyk":"กำไรและขาดทุนสุทธิลอยตัว",
     "pcsl":"ปริมาณปิด",
     "qrpc":"ยืนยันการปิดตำแหน่ง",
     "ypc":"ปิดตำแหน่งแล้ว",
     "ss2":"มากมาย",
     "qsrss":"กรอกขนาดล็อต",
   },
   "gjrz":{
     "sfyz":"การรับรอง KYC",
     "t1":"1. รองรับรูปภาพรูปแบบ JPG, JPEG หรือ PNG ที่มีขนาดเล็กกว่า 8M",
     "t2":"2. ภาพถ่ายติดบัตรจะต้องชัดเจน และไม่อนุญาตให้แก้ไขหรือปิดกั้น ต้องมองเห็นรูปถ่าย หมายเลขประจำตัว และชื่อได้ชัดเจน",
     "t3":"3. ต้องถ่ายภาพโดยไม่สวมหมวก และแนะนำว่าอย่าแต่งหน้า ใบหน้าของบุคคลที่ถือเอกสารจะต้องมองเห็นได้ชัดเจน และต้องเปิดออกทั้งแขน",
     "t4":"ตกลง",
     "bh":"ปฏิเสธ",
     "shz":"ภายใต้การทบทวน",
     "shtg":"สอบผ่านแล้ว",
     "nyrzcg":"คุณได้รับการรับรองความถูกต้องเรียบร้อยแล้ว",
     "sczjz":"อัปโหลดรูปถ่ายประจำตัว",
     "sczjzmz":"อัปโหลดรูปถ่ายด้านหน้าของบัตรประจำตัวของคุณ",
     "sczjbmz":"อัปโหลดรูปถ่ายด้านหลังบัตรประจำตัวของคุณ",
     "scgrqmz":"อัปโหลดรูปถ่ายบัตรประจำตัวของคุณในมือ",
     "gjlb":"รายชื่อประเทศ",
     "qxzgjlb":"เลือกประเทศ/ภูมิภาค",
     "zsxm":"ชื่อจริง",
     "qsrzsxm":"กรอกชื่อจริงของคุณ",
     "zjlx":"ประเภทของใบรับรอง: ",
     "zjhm":"หมายเลขประจำตัวประชาชน",
     "qsrzjhm":"กรอกหมายเลขประจำตัวของคุณ",
     "khh":"ธนาคารเปิดบัญชี",
     "qsrkhh":"ป้อนธนาคารที่เปิดบัญชี",
     "yhkh":"หมายเลขบัตรธนาคาร",
     "qsryhkh":"ป้อนหมายเลขบัตรธนาคาร",
   },
   "status":{
     "statusText":['ล้มเหลว','อยู่ระหว่างตรวจทาน','สำเร็จ'],
   },
   "download":{
     "t1":"การซื้อขายผ่านมือถือทุกที่ทุกเวลา",
     "xz":"ดาวน์โหลด",
   },
   "langNew":{
     'cxsqsh': "สมัครใหม่อีกครั้ง",
     "jxtg": "โฮสต์ต่อไป",
     "szhb": "สกุลเงินดิจิทัล",
     "gjs": "โลหะ",
     "ny": "พลังงาน",
     "yy": "น้ำมันดิบ",
     "jy": "ซื้อขาย",
     "jmhb": "สกุลเงินดิจิทัล",
     "yxhy": "สัญญาถาวร",
     "gdjy": "คำสั่งซื้อที่รอดำเนินการ",
     "khh": "ธนาคารบัญชี",
     "qsrkhh": "กรุณากรอกธนาคาร",
     "yhkh": "บัญชีธนาคาร",
     "qsryhkh": "กรุณาใส่เลขบัญชีธนาคาร",
     "mnzh":"บัญชีทดลอง",
     "zjjypt":"แพลตฟอร์มการซื้อขายที่ดีที่สุด",
     "brjmzndxq":"ซอฟต์แวร์นี้ตอบสนองทุกความต้องการของคุณด้วยความเชี่ยวชาญทางเทคนิคที่ดีที่สุด",
     "jx":"ดำเนินการต่อ",
     "yssm":"คำชี้แจงสิทธิส่วนบุคคล",
     "fxqzc":"นโยบายต่อต้านการฟอกเงิน",
     "jgxkz":"ใบอนุญาตตามกฎระเบียบ",
     "ckgd":"มากกว่า",
     "gd":"มากกว่า",
     "dd":"คำสั่ง",
     "ckdd":"ดูคำสั่งซื้อ",
     "yxdd":"ตลอดไป",
     "qqdd":"ตัวเลือก",
     "hand":"เยอะมาก= ",
     "lxwm":"ติดต่อเรา",
     "tpfzl":"วางภาพของคุณที่นี่หรือ ",
     "liulang":"เรียกดู",
     "zctpgs":"รองรับ: JPG, JPEG2000, PNG",
     "ysr":"รายได้ต่อเดือน",
     "ndysr":"รายได้ต่อเดือนของคุณ",
     "qsrndysr":"ป้อนรายได้ต่อเดือนของคุณ",
     "yqtzje":"จำนวนเงินลงทุนที่คาดหวัง",
     "qsrtzje":"ป้อนจำนวนเงินลงทุนที่คาดหวัง",
     "zszh":"บัญชีจริง",
     "qdl":"กรุณาเข้าสู่ระบบ",
     "zx": "รายการโปรด",
     "hkdz":"ที่อยู่การชำระหนี้",
     "dkje":"จำนวนเงินกู้: ",
     "zlx":"ดอกเบี้ยรวม: ",
     "hkze":"รวมการชำระคืน: ",
     "qcz":"ไปฝาก",
     "yebz":"ยอดคงเหลือของคุณไม่เพียงพอ โปรดเติมเงิน",
     "dhje":"จำนวนเงินที่จะชำระคืน：",
     "hkjl":"คำสั่งชำระหนี้：",
     "hkje":"ยอดเงินคงเหลือ：",
     "kyye":"จำนวนเงินชำระคืน：",
     "qb": 'ทั้งหมด',
     "lmc": "ชื่อลูกโซ่：",
     "search": "ရှာရန်",
     "mrjg":"ราคา",
     "lxkf":"ติดต่อ",
     "wyj":"การละเมิดสัญญา",
     "yxsj":"กำลังดำเนินการ：",
     "jssj":"เสร็จ：",
     "hksj":"การชำระคืน：",
     "sysj":"เหลือเวลา：",
     "jkqx":"ระยะเวลากู้ยืม：",
     "yq":"ค้างชำระ：",
     "qqss":"คำสั่งซื้อขายตัวเลือกของคุณหมดอายุแล้ว และการสูญเสียของคุณคือ",
     "qqlr":"คำสั่งซื้อขายออปชั่นของคุณหมดอายุแล้ว และกำไรของคุณก็เท่ากับ",
     "bz":"สกุลเงิน",
     "dzje":"จำนวนเงินที่ได้รับ",
     "lxyxzc":"การสนับสนุนทางอีเมล",

     "mnzh": "บัญชีทดลอง",
         "zszh": "บัญชีจริง",
         "qsrgjc": "กรุณาใส่คีย์เวิร์ด",
         "wh": "ฟอเร็กซ์",
         "szhb": "สกุลเงินดิจิทัล",
         "js": "โลหะ",
         "ny": "พลังงาน",
         "sj": "ราคาตลาด",
         "gd": "คำสั่งซื้อที่รอดำเนินการ",
         "mr": "ซื้อ",
         "mc": "ขาย",
         "ss": "ขนาดล็อต",
         "qsrss": "กรุณาระบุขนาดล็อต",
         "zy": "ทำกำไร",
         "zs": "หยุดการขาดทุน",
         "qsrzyj": "โปรดป้อนราคาขายทำกำไร",
         "qsrzsj": "โปรดป้อนราคาหยุดการขาดทุน",
         "xfbzj": "ต้องการมาร์จิ้น:",
         "kyye": "ยอดคงเหลือที่ใช้ได้:",
         "cc": "ตำแหน่ง",
         "ypc": "สถานะปิด",
         "name": "ชื่อ",
         "ddh": "หมายเลขคำสั่งซื้อ",
         "mmfx": "ทิศทางการซื้อและขาย",
         "gmfs": "วิธีการซื้อ",
         "xdj": "ราคาสั่งซื้อ",
         "sxf": "ค่าบริการ",
         "sxf2": "ค่าธรรมเนียมการจัดการ:",
         "cz": "การดำเนินการ",
         "pc": "ปิดตำแหน่ง",
         "cx": "เลิกทำ",
         "pccg": "ปิดสำเร็จ",
         "dl": "เข้าสู่ระบบ",
         "yxhzhdl": "อีเมลและการเข้าสู่ระบบบัญชี",
         "qsryxhzh": "โปรดป้อนที่อยู่อีเมลหรือบัญชีของคุณ",
         "มม": "รหัสผ่าน",
         "qsrmm": "กรุณาใส่รหัสผ่าน",
         "cjxnzh": "สร้างบัญชีสาธิต",
         "wjmm": "ลืมรหัสผ่าน",
         "myzh": "ไม่มีบัญชี?",
         "zc": "การลงทะเบียน",
         "wjmm2": "ลืมรหัสผ่าน",
         "zh": "บัญชี",
         "qsrzh": "กรุณากรอกเลขที่บัญชี",
         "yzm": "รหัสยืนยัน",
         "qsryzm": "กรุณาใส่รหัสยืนยัน",
         "hqyzm": "รับรหัสยืนยัน",
         "qrmm": "ยืนยันรหัสผ่าน",
         "qzcsrmm": "กรุณาป้อนรหัสผ่านอีกครั้ง",
         "qd": "ตกลง",
         "yxh": "หมายเลขกล่องจดหมาย",
         "qsryxh": "กรุณาใส่หมายเลขกล่องจดหมายของคุณ",
         "sjh": "หมายเลขโทรศัพท์มือถือ",
         "qsrsjh": "กรุณากรอกหมายเลขโทรศัพท์",
         "xm": "ชื่อ",
         "qsrxm": "กรุณากรอกชื่อ",
         "gj": "สัญชาติ",
         "qxzgj": "กรุณาเลือกสัญชาติ",
         "zjlx": "ประเภทใบรับรอง",
         "qxzzjlx": "กรุณาเลือกประเภทเอกสาร",
         "zjhm": "หมายเลขเอกสาร",
         "qsrzjhm": "กรุณากรอกหมายเลขประจำตัวประชาชน",
         "qpsbsczj": "กรุณาถ่ายรูปและอัพโหลด ID ของคุณ",
         "pszm": "ยิงด้านหน้า",
         "psfm": "ยิงจากด้านหลัง",
         "qsczmz": "กรุณาอัปโหลดภาพด้านหน้า",
         "qscfmz": "โปรดอัปโหลดรูปภาพย้อนกลับ",
         "scqmz": "ถือรูปถ่ายที่มีลายเซ็น",
         "qscqmz": "โปรดอัปโหลดรูปภาพที่มีลายเซ็น",
         "wyyd": "ฉันได้อ่านและเข้าใจ",
         "yhxy": "ข้อตกลงผู้ใช้",
         "grzx": "ศูนย์ส่วนบุคคล",
         "gnlb": "รายการฟังก์ชัน",
         "smrz": "การตรวจสอบชื่อจริง",
         "rj": "เงินฝาก",
         "cj": "การถอน",
         "zhjl": "บันทึกบัญชี",
         "xx": "ข้อความ",
         "wdyq": "คำเชิญของฉัน",
         "zhaq": "ความปลอดภัยของบัญชี",
         "sz": "การตั้งค่า",
         "lmc": "ชื่อเชน",
         "bcewm": "บันทึกคิวอาร์โค้ด",
         "fzdz": "คัดลอกที่อยู่",
         "fzcg": "คัดลอกสำเร็จ",
         "rjsl": "จำนวนเงินฝาก",
         "qsrsl": "กรุณาใส่จำนวน",
         "zdsl": "ปริมาณขั้นต่ำ",
         "pzms": "ค่าแฮช",
         "qsrpzms": "โปรดป้อนค่าแฮช",
         "lkrj": "ฝากเงินทันที",
         "cjdz": "ที่อยู่ถอน",
         "qsrcjdz": "โปรดป้อนที่อยู่ถอนเงิน",
         "cjsl": "จำนวนเงินที่ถอน",
         "qsrcjsl": "กรุณากรอกจำนวนเงินที่ถอน",
         "lkcj": "ถอนทันที",
         "ddh2": "หมายเลขคำสั่งซื้อ:",
         "time": "เวลา:",
         "je": "จำนวนเงิน:",
         "zt": "สถานะ:",
         "bt": "ชื่อเรื่อง:",
         "nr": "เนื้อหา:",
         "sqz": "กำลังสมัคร",
         "yqhy": "ชวนเพื่อน",
         "yqhyyqzc": "ชวนเพื่อนมาลงทะเบียนด้วยกัน",
         "wdyqm": "รหัสเชิญของฉัน",
         "wdyqlj": "ลิงก์คำเชิญของฉัน",
         "fz": "คัดลอก",
         "xgdlmm": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
         "szjymm": "ตั้งรหัสผ่านการทำธุรกรรม",
         "xgmm": "เปลี่ยนรหัสผ่าน",
         "tgyzmxgmm": "เปลี่ยนรหัสผ่านโดยใช้รหัสยืนยัน",
         "jmm": "รหัสผ่านเก่า",
         "qsrjmm": "โปรดป้อนรหัสผ่านเดิม",
         "dlmm": "รหัสผ่านเข้าสู่ระบบ",
         "qsrdlmm": "กรุณาใส่รหัสผ่านเข้าสู่ระบบ",
         "jymm": "รหัสผ่านการทำธุรกรรม",
         "qsrjymm": "โปรดป้อนรหัสผ่านการทำธุรกรรม",
         "mmcd": "รหัสผ่านยาว 6 หลัก",
         "tcdl": "ออกจากระบบ",
         "zxkf": "บริการลูกค้าออนไลน์",
         "bzzx": "ศูนย์ช่วยเหลือ",
         "ksrm": "การเริ่มต้นอย่างรวดเร็ว",
         "kcjg": "ราคาตำแหน่งเปิด",
         "pcjg": "ราคาปิด",
         "gdjg": "ราคาคำสั่งที่รอดำเนินการ",
         "pcfs": "ปิดตำแหน่ง",
         "hyl": "จำนวนสัญญา",
         "thbzj": "คืนเงินประกันเงินฝาก",
         "gmsl": "ปริมาณการซื้อ",
         "sysl": "ปริมาณคงเหลือ",
         "sccg": "บันทึกสำเร็จ",
         "qxdl": "กรุณาเข้าสู่ระบบก่อน",
         "sy": "รายได้",
         "tj": "ส่ง",
         "sfz": "บัตรประจำตัว",
         "hz": "หนังสือเดินทาง",
         "jz": "ใบขับขี่",
         "qt": "อื่นๆ",
         "qxzmnje": "กรุณาเลือกจำนวนเงินจำลอง",
         "cjmnzhcg": "สร้างบัญชีทดลองสำเร็จ!",
         "dlmmts": "กรุณาใส่รหัสผ่านเข้าสู่ระบบ",
         "mmts": "รหัสผ่านมีความยาว 6-24 หลัก",
         "jymmts": "รหัสผ่านยาว 6 หลัก",
         "shz": "กำลังตรวจสอบ",
         "shtg": "อนุมัติ",
         "jj": "ปฏิเสธ",
         "xyb": "ถัดไป",
         "emailgsts": "ที่อยู่อีเมลที่ป้อนไม่เป็นไปตามกฎ",
         "telgsts": "รูปแบบของหมายเลขโทรศัพท์มือถือที่ป้อนไม่ถูกต้อง",
         "lcmmbyz": "รหัสผ่านสองรหัสที่ป้อนไม่สอดคล้องกัน",
         "gdj": "ราคาคำสั่งที่รอดำเนินการ",
         "lx": "ประเภท",
         "qsrgdj": "โปรดป้อนราคาคำสั่งซื้อที่รอดำเนินการ",
         "kccg": "เปิดตำแหน่งสำเร็จ!",
         "pcsl": "ปริมาณปิด",
         "mnts": "บัญชีเสมือนหมดอายุ โปรดสร้างใหม่",
         "wtfa": "แผนการมอบหมาย",
         "kcsj": "เวลาเปิดตำแหน่ง",
         "gbsj": "เวลาปิด",
         "gylx": "แลกเปลี่ยน",
         "hyjy": "สัญญา",
         "zwsj": "ยังไม่มีข้อมูล",
         "zwkf": "ช่องเติมเงินนี้ยังไม่ได้เปิด",
   },
   "langNew9":{
   "dzje":"แนวโน้มตลาดของผลิตภัณฑ์การซื้อขาย",
   "lxyxzc":"เริ่มต้นเส้นทางการซื้อขายดิจิทัลของคุณ",
   "text1":"เริ่มต้นด้วยการสร้างบัญชี",
   "text2":"เชิญเพื่อนเข้าร่วม MFTG เพื่อเล่นด้วยกัน",
   "text3":"เติมเงินในบัญชีของคุณ",
   "text4":"รองรับการเติมเงินหลายสกุลเงิน ช่วยให้คุณเริ่มซื้อขายได้อย่างรวดเร็ว",
   "text5":"เริ่มซื้อขาย",
   "text6":"มีคู่ซื้อขายคุณภาพสูงให้เลือกหลากหลาย และซื้อขายอย่างมีความสุขใน MFTG",
    "text7":"เชิญเพื่อนมาเพื่อรับ USDT",
    "text8":"เชิญเพื่อนมาเพื่อรับ USDT ได้อย่างง่ายดาย",
    "text9":"ฟังก์ชันสินเชื่อออนไลน์",
    "text10":"เมื่อคุณไม่มีเงิน คุณสามารถสมัครขอสินเชื่อซึ่งจะออกให้เร็วที่สุดในวันเดียวกัน",
   "text11":"ซื้อขายสินทรัพย์ทั้งหมด",
   "text12":"ฟอเร็กซ์, สกุลเงินดิจิทัล, ฟิวเจอร์ส, ETF, ฯลฯ",
   },
   "bank":{
     "text1":"แพลตฟอร์มการจัดการทางการเงินที่น่าเชื่อถือที่สุดของคุณ",
     "text2":"การแจ้งเตือนข่าวเรียลไทม์",
     "text3":"ทำความเข้าใจข้อมูลแบบเรียลไทม์เกี่ยวกับอุตสาหกรรมการเงิน",
     "text4":"เริ่มเข้าใจ",
     "text5":"ข่าวแฟลช",
     "text6":"เลือกธนาคาร",
     "text7":"บัตรธนาคาร",
     "text8":"จำนวน...",
     "text9":"เพิ่มบัตรธนาคาร",
     "text10":"บัญชีธนาคาร",
     "text11":"กรุณากรอกบัญชีธนาคาร",
     "text12":"รหัสบัตร",
     "text13":"กรุณากรอกรหัสหมายเลขบัตร",
     "text14":"รหัสระหว่างประเทศของธนาคาร",
     "text15":"รหัสระหว่างประเทศของธนาคาร",
     "text16":"กรุณากรอกหมายเลขโทรศัพท์",
     "text17":"เพิ่มไปที่",
     "text18":"ลบบัตรธนาคาร",
     "text19":"ข้อมูลการถอนเงินจริง",
     "text20":"ข้อมูลการถอนเงิน",
     "text21":"เลือกบัตรธนาคาร",
     "text22":"หมายเหตุ",
     "text23":"จำนวนเงินถอนขั้นต่ำ:",
     "text24":"ไม่อนุญาตให้ถอนเงินหากจำนวนเงินน้อยกว่าจำนวนเงินถอนขั้นต่ำ",
     "text25":"• เพื่อความปลอดภัยของเงิน เมื่อนโยบายความปลอดภัยของบัญชีของคุณเปลี่ยนแปลงหรือรหัสผ่านเปลี่ยนแปลง เราจะตรวจสอบการถอนเงินด้วยตนเอง โปรดรออย่างอดทนให้เจ้าหน้าที่ติดต่อคุณทางโทรศัพท์หรืออีเมล",
     "text26":"• โปรดตรวจสอบให้แน่ใจว่าคอมพิวเตอร์และเบราว์เซอร์ของคุณปลอดภัย เพื่อป้องกันไม่ให้ข้อมูลถูกแทรกแซงหรือรั่วไหล",
     "text27":"• สำหรับ USD ที่คุณถอนออก การดำเนินการแต่ละครั้งหมายถึงจำนวนทรัพย์สินทั้งหมดที่แสดงในหน้าการถอนเงินที่คุณมีจะลดลงตามจำนวนเงินถอนที่สอดคล้องกัน",
     "text28":"บันทึกการถอนเงิน",
     "text29":"ประเภทสกุลเงินของเฟียต",
   },
   "kxt": {
       "fs": "time",
       "fz":"min",
       "xs":"hour",
       "tian":"day",
       "zhou":"week",
     },
     "xbsg":{
       "title": "Startup",
       "wdsg": "รายละเอียด",
       "scts": "ล็อควัน:",
       "sy": "ที่เหลือ",
       "ljsg": "สมัครสมาชิกตอนนี้",
       "ysk": "ขายหมดแล้ว",
       "xzjdy": "สมัครตอนนี้",
       "dy": "สมัครสมาชิก",
       "fxjg": "ราคาออก",
       "fxl": "การไหลเวียน",
       "ssrq": "วันที่จดทะเบียน",
       "yxqx": "วันหมดอายุ",
       "qsrsl": "กรุณาใส่จำนวน",
       "syl": "จำนวนคงเหลือ",
       "sgrq": "วันที่ซื้อ",
       "sgsl": "ปริมาณการซื้อ",
       "bz": "สกุลเงิน",
       "yebz": "ยอดเงิน USDT ไม่เพียงพอ",
       "tgsl": "ปริมาณการส่ง",
       "shz": "กำลังตรวจสอบ",
       "wtg": "ล้มเหลว",
       "ytg": "ผ่าน",
       "ffsb": "การออกล้มเหลว",
       "yth": "คืนเงิน",
       "sbly": "เหตุผลความล้มเหลว",
       "jjly": "เหตุผลในการปฏิเสธ",
       "bz2": "สกุลเงิน:",
       "fxjg2": "ราคาออก:",
       "sgsl2": "จำนวนซื้อ:",
       "tgsl2": "ปริมาณการส่ง:",
       "sssj": "เวลาออกสู่ตลาด",
       "sssj2": "เวลาออกสู่ตลาด:",
       "sgj": "ราคาสมัครสมาชิก",
       "sgj2": "ราคาซื้อ:",
       "sgsj": "เวลาซื้อ",
       "sgsj2": "เวลาซื้อ:",
       "sbly2": "เหตุผลความล้มเหลว:",
       "jjly2": "เหตุผลในการปฏิเสธ:",
       "bzj": "ระยะขอบ:",
       "zsxf": "ค่าธรรมเนียมการทำธุรกรรมทั้งหมด:",
       "djze": "จำนวนเงินทั้งหมดที่ถูกแช่แข็ง:",
       "djje": "จำนวนการตรึง"
       },
       "bzhl": {
         "title": "เงินปันผล",
         "gz": "กติกา",
         "tgdd": "คำสั่งเอสโครว์",
         "zztgdzj": "กองทุนภายใต้การดูแล",
         "yjjrsy": "รายได้วันนี้",
         "ljsy": "รายได้สะสม",
         "tgzdd": "คำสั่งที่รอดำเนินการ",
         "cljxcp": "ผลิตภัณฑ์เชิงกลยุทธ์",
         "dbxe": "จำกัดยอดเดียว",
         "rsyl": "อัตราผลตอบแทนรายวัน",
         "zq": "รายสัปดาห์",
         "qmr": "ซื้อทันที",
         "bbzhzc": "ทรัพย์สินทางบัญชี",
         "dd": "คำสั่ง",
         "buy": "ซื้อเข้า",
         "jxcp": "สินค้าแนะนำ",
         "ckdd": "ตรวจสอบคำสั่งซื้อ",
         "gd": "มากกว่า",
         "xzbzts": "ง่ายและปลอดภัย สามารถเลือกเงินปันผลได้หลายสกุลเงิน",
         "qtbz": "เหรียญอื่นๆ",
         "zrsy": "รายได้เมื่อวาน",
         "zdisyl": "ผลตอบแทนขั้นต่ำ",
         "zdasyl": "ผลผลิตสูงสุด",
         "day": "วัน",

         title1: 'ปริมาณ AI',
         ttzbt: 'สร้างรายได้ทุกวัน',
         wdtg: 'โฮสติ้งของฉัน',
         zztgdzj: 'กองทุนภายใต้การดูแล',
         yjjrsy: 'ประมาณการทุกวัน',
         ljsy: 'รายได้สะสม',
         tgzdd: 'คำสั่งที่รอดำเนินการ',
         tgdd: 'คำสั่งเอสโครว์',
         t1: 'การจัดการทางการเงินที่มีความเสี่ยงต่ำและมีเสถียรภาพ สามารถแลกคืนได้ทุกเมื่อหากจำเป็น',
         t2: 'ผู้ช่วยจัดการเงินของคุณฟรี',
         cljxcp: 'อายุผลิตภัณฑ์',
         dbxe: 'จำกัดยอดเดียว',
         rsyl: 'อัตราผลตอบแทนรายวัน (%)',
         rsyl2: 'อัตราผลตอบแทนรายวัน：',
         zq: 'รายสัปดาห์',
         qmr: 'ไปซื้อ',
         ckgd: 'ดูเพิ่มเติม',
         cpgk: 'ภาพรวมผลิตภัณฑ์',
         pxsj: 'เวลาปันผล',
         tgzj: 'ทุนการดูแล',
         tqsh: 'ไถ่ถอนก่อนกำหนด',
         cpld: 'จุดเด่นของผลิตภัณฑ์',
         cpgz: 'กฎผลิตภัณฑ์',
         cont: 'การย้ายอิฐคือการโฮสต์ USDT บนแพลตฟอร์มและทีมงานมืออาชีพของแพลตฟอร์มดำเนินการสิทธิ์ในการย้ายอิฐ ผู้เข้าร่วมจะได้รับส่วนแบ่งรายได้จากการเคลื่อนย้ายอิฐของแพลตฟอร์มในช่วงระยะเวลาการดูแลกองทุน ซึ่งสามารถเข้าถึงได้ทุกเมื่อ ที่ปลอดภัยและสะดวก',
         zj: 'ทุน 100%',
         aqbz: 'ความปลอดภัย',
         jjrsy: 'รายได้วันหยุด',
         bjd: 'ไม่ขาดตอน',
         cgcrh: 'หลังฝากสำเร็จ',
         dtqx: 'วันหยุด',
         ljzr: 'โอนเลย',
         xqglgj: 'เครื่องมือจัดการเงินฟรี',
         ddh: 'เลขที่ใบสั่งซื้อ',
         tgje: 'ยอดเงินการดูแล',
         tgsj: 'รอบวัน',
         yhl: 'กำไร/วันคงเหลือ',
         xdsj: 'เวลาคำสั่งซื้อ',
         zt: 'สถานะ',
         fh: 'กลับ',
         qrnhsy: 'รายได้ต่อปีเจ็ดวัน',
         ygy: '1个月',
         bn: '半年',
         yn: '1年',
         yuan: 'หยวน',
         tzfx: 'ความเสี่ยงในการลงทุน',
         shsc: 'เวลาแลกรับ',
         di: 'ต่ำ',
         yggzr: 'หนึ่งวันทำการ',
         msgsxf: 'ฟรีค่าสมัคร',
         mr: 'ทุกวัน',
         dqfh: 'ผลตอบแทนเมื่อครบกำหนด',
         ljgm: 'ซื้อทันที',
         tgz: 'ระหว่าการดูแล',
         sh: 'การไถ่ถอน',
         ywc: 'สำเร็จ',
         ysh: 'ถอนคืนแล้ว',
         all: 'ทั้งหมด',
         "xzbzts": "ง่ายและปลอดภัย สามารถเลือกเงินปันผลได้หลายสกุลเงิน",
         "qtbz": "เหรียญอื่นๆ"
       },
       "bzhlgm": {
         "qtzq": "USDT รอบ 7 วัน",
         "rsyl": "อัตราผลตอบแทนรายวัน (%)",
         "lczq": "การเงินรายสัปดาห์",
         "dbxe": "จำกัดยอดเดียว",
         "pxsj": "เวลาปันผล",
         "mr": "ทุกวัน",
         "dqfh": "ผลตอบแทนเมื่อครบกำหนด",
         "tgzj": "ทุนการดูแล",
         "tqsh": "รับการไถ่ถอน",
         "yjsy": "ผลตอบแทนโดยประมาณ (USDT)",
         "kyzc": "สินทรัพย์ที่มีอยู่ (USDT)",
         "cpjs": "รายละเอียดสินค้า",
         "tgje": "ยอดเงินการดูแล",
         "qsrtgje": "โปรดใส่ยอดเงินการดูแล",
         "qb": "ทั้งหมด",
         "rm": "ซื้อทันที",
         "cpzq": "อายุผลิตภัณฑ์",
         "gz": "เข้าใจกฎและสิทธิ์",
         "ktgje": "จำนวนเงินที่ฝากได้: ",
       },
       "bzhlwdtg": {
         "title": "สถานะคำสั่งซื้อ",
         "tgz": "ระหว่าการดูแล",
         "ywc": "สำเร็จ",
         "ysh": "ถอนคืนแล้ว",
         "tgje": "ยอดเงินการดูแล/จำนวนวันรอบสัปดาห์",
         "rsyl": "อัตราผลตอบแทนรายวัน",
         "yhl": "กำไร/วันคงเหลือ",
         "xdsj": "เวลาคำสั่งซื้อ",
         "sh": "การไถ่ถอน",
         "ddxq": "รายละเอียดคำสั่งซื้อ",
         "ddh": "เลขที่ใบสั่งซื้อ"
       },
       "bzjj": {
         "t1": "สร้างรายได้ทุกวัน",
         "cpld": "จุดเด่นของผลิตภัณฑ์",
         "scsq": "ฝากและรับได้ตลอดเวลา",
         "pxzq": "รอบการจ่ายเงินปันผล",
         "mtxf": "ออกทุกวัน",
         "hqlx": "ดอกเบี้ยออมทรัพย์",
         "zj": "ทุน 100%",
         "aqbz": "ความปลอดภัย",
         "jjrsy": "รายได้วันหยุด",
         "sybjd": "รายได้ไม่ขาดตอน",
         "bjd": "ไม่ขาดตอน",
         "cgcrh": "หลังฝากสำเร็จ",
         "dtqx": "วันหยุด",
         "jglz": "ตัวอย่างเช่น",
         "syjs": "การคำนวณรายได้",
         "cont2": "ขั้นต่ำ: 10000U× 0.3%-30U",
         "cont3": "สูงสุด: 10000U× 0.5%-50U",
         "gywyj": "เกี่ยวกับค่าผิดสัญญา",
         "wycy": "อยากมีส่วนร่วม"
       },
       "wydb": {
         "title": "ฉันต้องการเงินกู้",
         "db": "สกุลเงิน",
         "dbz": "เป็นสกุลเงิน",
         "jl": "บันทึก",
         "jdzq": "ระยะเวลายืม (วัน)",
         "qhk": "ไปชำระคืน",
         "ljdb": "สกุลเงินเงินกู้สะสม (usdt)",
         "dhkbs" : "จำนวนการชำระคืนที่รอดำเนินการ",
         "jkje": "จำนวนเงินกู้ (usdt)",
         "qsrje": "กรุณาใส่จำนวนเงิน",
         "rll": "อัตรารายวัน",
         "hkfs": "วิธีการชำระคืน",
         "dqych": "ชำระคืนเงินต้นและดอกเบี้ยเมื่อครบกำหนด",
         "lx": "ดอกเบี้ย",
         "fkjg": "สถาบันสินเชื่อ",
         "tpsc": "สินเชื่อสินเชื่อ (อัพโหลดภาพ)",
         "fwxx": "ข้อมูลบ้าน",
         "srzm": "หลักฐานแสดงรายได้",
         "yhmx": "รายละเอียดธนาคาร",
         "qscfwxx": "โปรดอัปโหลดข้อมูลที่อยู่อาศัย",
         "qscsrzm": "กรุณาอัพโหลดหลักฐานรายได้",
         "qscyhmx": "กรุณาอัพโหลดรายละเอียดธนาคาร",
         "qsczjz": "กรุณาอัพโหลดรูปประจำตัว",
         "zzz": "รูปถ่ายติดบัตร",
         "yd": "ฉันได้อ่านและยอมรับ",
         "xy": "ข้อตกลงเงินกู้แอปพลิเคชัน",
         "sqdb": "คลิกเพื่อสมัครสินเชื่อ",
         "gb": "ปิด",
         "qd": "ตกลง",
         "ts": "โปรดตรวจสอบสัญญาเงินกู้",
         "dbjl": "บันทึกเงินกู้",
         "hkhth": "เลขที่สัญญาเงินกู้",
         "wsh": "ยังไม่ได้ตรวจสอบ",
         "yfk": "เบิกจ่าย",
         "sqrq": "วันที่สมัคร",
         "zq": "ระยะเวลา",
         "dbsl": "จำนวนเงินกู้",
         "zhke": "จำนวนเงินที่ชำระคืนทั้งหมด",
         "yhkxq": "รายละเอียดการชำระคืน",
         "bqyhk": "การชำระคืนในช่วงเวลานี้ (USDT)",
         "hktips": "โปรดตรวจสอบว่ายอดเงินคงเหลือเพียงพอ หากยอดเงินไม่เพียงพอ โปรดเติมเงินก่อนที่จะชำระคืน",
         "bj": "อาจารย์ใหญ่",
         "jie": "ยืม",
         "ljhk": "ชำระคืนทันที",
         "qcz": "ไปเติมเงิน",
         "yebzqxcz": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนชำระคืน",
         "znj": "ค่าธรรมเนียมการชำระล่าช้า",
         "yqts": "จำนวนวันที่เกินกำหนด",
         "kjdje": "จำนวนเงินที่ยืมได้",
         "rlxl": "อัตราดอกเบี้ยรายวัน",
         "rlxl2": "อัตราดอกเบี้ยรายวัน:",
         "yqll": "อัตราดอกเบี้ยรอการตัดบัญชี",
         "yqll2": "อัตราดอกเบี้ยรอการตัดบัญชี:",
         "ljlx": "ดอกเบี้ยสะสม",
         "zrlx": "ความสนใจของเมื่อวาน",
         "jddd": "คำสั่งยืม",
         "zxje": "จำนวนเงินขั้นต่ำ:",
         "jexz": "จำนวนจำกัด:",
         "xypztp": "รูปภาพประจำตัว:",
         "hkpztp": "ภาพใบสำคัญการชำระคืน:",
         "ysxsl": "จำนวนดอกเบี้ยที่ได้รับ:",
         "ysxts": "จำนวนวันที่เกิดดอกเบี้ย:",
         "jdsl": "จำนวนเงินกู้:",
         "fkjg2": "สถาบันสินเชื่อ:",
         "zq2": "ระยะเวลา:",
         "sqrq2": "วันที่สมัคร:",
         "zhke2": "ยอดชำระคืนทั้งหมด:",
         "yff": "ออก",
         "hkz": "การชำระคืน",
         "yjq": "เคลียร์",
         "jjdk": "ปฏิเสธเงินกู้",
         "ch": "ถอน",
         "cxsq": "สมัครใหม่",
         "cgkdkxz": "เกินวงเงินกู้ยืม",
         "hdgz": "กติกากิจกรรม"
       },
       "xyf": {
         "title": "คะแนนเครดิต",
         "dqxyf": "คะแนนเครดิตปัจจุบัน",
         "hwqxyf": "คุณไม่ได้รับคะแนนเครดิต",
         "zwxyf": "ยังไม่มีคะแนนเครดิต",
         "pgsj": "เวลาประเมิน",
         "xypz": "ข้อมูลประจำตัว (อัปโหลดภาพ)",
         "cxtjsh": "ส่งอีกครั้งเพื่อตรวจสอบ",
         "tjsh": "ส่งเพื่อตรวจสอบ",
         "yjj": "ปฏิเสธ",
         "hq": "รับ",
         "qx": "ยกเลิก",
         "qxwcsmrz": "ตรวจสอบชื่อจริงให้เสร็จสมบูรณ์ก่อน"
       },
       "hkxq":{
         "dd": "สั่งซื้อ",
         "fzhkdz": "คัดลอกที่อยู่ชำระ",
         "hkxq": "รายละเอียดการชำระคืน",
         "zlx": "ดอกเบี้ยทั้งหมด",
         "zhk": "การชำระคืนทั้งหมด",
         "hkjg": "หน่วยงานชำระคืน",
         "qschkpz": "กรุณาอัปโหลดใบสำคัญจ่ายคืน",
         "hkpz": "ใบสำคัญจ่ายคืน",
         "lxkfhk": "ติดต่อฝ่ายบริการลูกค้าเพื่อชำระเงิน"
       },
       "tipsNew":{
         "wjmmts": "กู้คืนรหัสผ่านด้วยรหัสยืนยัน",
         "qscpztp": "อัพโหลดภาพบัตรกำนัล",
         "emailgsts": "กรุณาใส่อีเมลที่ถูกต้อง",
         "telgsts": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
         "lcmmbyz": "กรุณายืนยันรหัสผ่านของคุณ",
         "zdsl": "จำนวนขั้นต่ำ ",
         "sldydy": "ปริมาณที่มากกว่าหรือเท่ากับ",
         "zxtzsl": "จำนวนเงินลงทุนขั้นต่ำ ",
         "ddz": "ที่รอ",
         "xs": "ชั่วโมง",
         "min": "จำนวนขั้นต่ำ ",
         "max": "จำนวนสูงสุด ",
         "yebz": "ยอดเงินไม่เพียงพอ",
         "qsrss": "กรุณาใส่ล็อต",
         "zdss": "ล็อตขั้นต่ำ",
         "yjj": "ถูกปฏิเสธ",
         "shz": "การไถ่ถอน"
       },
       "status":{
         "statusText": ['ความล้มเหลว','รอดำเนินการ','ความสำเร็จ'],
       },
       "jghy": {
         "jghy": "สัญญาการส่งมอบ",
         "yxhy": "สัญญาถาวร",
         "mz": "งั้น",
         "md": "งุ่มง่าม",
         "gmj": "ราคาซื้อ",
         "jsj": "ราคาชำระ",
         "xj": "ราคาปัจจุบัน",
         "fx": "ทิศทาง",
         "sl": "ปริมาณ",
         "jgsj": "เวลาจัดส่ง",
         "gb": "ปิดตัวลง",
         "jxxd": "สั่งซื้อต่อ",
         "cclb": "รายชื่อตำแหน่ง",
         "zc": "ถืออยู่",
         "lscc": "ประวัติการถือ",
         "qblx": "ทุกประเภท",
         "yk": "กำไรขาดทุน",
         "ddqr": "ยืนยันการสั่งซื้อ",
         "dqsj": "วันที่ครบอายุ",
         "jssj": "เวลาตัดบัญชี",
         "sy": "รายได้",
         "tzje": "จำนวนเงินลงทุน",
         "zdje": "จำนวนเงินลงทุนมากกว่า 0",
         "kyye": "มีอยู่",
         "sxf":"ค่าธรรมเนียมการจัดการ",
         "sxfl": "อัตราค่าธรรมเนียม",
         "jypz": "ประเภทการซื้อขาย",
         "jyfx": "ทิศทางการซื้อขาย",
         "qrxd": "ยืนยันสั่งซื้อ",
         "dqye": "ยอดคงเหลือ",
         "zt": "สถานะ"
       },
       "bbjy":{
        "cjsj":"เวลาทำธุรกรรม",
        "wtjg":"ราคาคอมมิชชั่น",
        "cjjg":"ราคาการทำธุรกรรม",
        "wcj":"ไม่มีการทำธุรกรรม",
        "ycj":"การทำธุรกรรมเสร็จสมบูรณ์",
        "yqx":"ยกเลิก",
        "qxwt":"ยกเลิกการมอบหมาย",
        "qsrxj":"กรุณากรอกราคาจำกัด"
      }
   // "langNew2":{
   //   "sy":"หน้าแรก",
   //   "sc":"ตลาด",
   //   "sclb":"รายการตลาด",
   //   "jy":"ซื้อขาย",
   //   "zh":"บัญชี",
   //   "db":"เงินกู้",
   //   "zchm":"ทะเบียนเลขที่",
   //   "cp":"ผลิตภัณฑ์",
   //   "tzjd":"สินเชื่อเพื่อการลงทุน",
   //   "zxzc":"การสนับสนุนทางออนไลน์",
   //   "xd":"คำสั่ง",
   //   "zzjptgmnr":"ลงทุนในอนาคตของคุณ ขยายพอร์ตโฟลิโอของคุณในระบบการเงินที่ยุติธรรมและเปิดกว้าง",
   //   "yy":"แอป",
   //   "pqnr":"ธนาคารบนมือถือที่ฉีกกฎเกณฑ์เดิมๆ และมอบเครื่องมือการจัดการทางการเงินที่แม่นยำแก่คุณ",
   //   "jiami":"การเข้ารหัสลับ",
   //   "tgnr":"ด้วยการฝากเงินโดยใช้สกุลเงินดิจิทัล คุณจะได้รับความปลอดภัยอีกชั้นหนึ่งและรับประกันการประมวลผลธุรกรรมที่รวดเร็ว",
   //   "jyl":"ปริมาณการซื้อขาย 24 ชม",
   //   "ssjmhb":"รายการ Crypto",
   //   "zchy":"ผู้ใช้ที่ลงทะเบียน",
   //   "djxz":"คลิกเพื่อดาวน์โหลด",
   //   "azsc":"แอนดรอยด์มาร์เก็ต",
   //   "pgsd":"แอปเปิ้ลสโตร์",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/ty.js